// This file is auto-generated by @hey-api/openapi-ts

export type AdminAuthResponseDto = {
    success: boolean;
    message: string;
    accessToken: string;
    refreshToken: string;
    user: AdminUserDto;
};

export type AdminBookingCarDto = {
    uuid: string;
    make: string;
    model: string;
    license_plate: string;
    class: string;
    generated_image: (string) | null;
};

export type AdminBookingClientDto = {
    uuid: string;
    name: string;
    phone: string;
};

export type AdminBookingListResponseDto = {
    data: Array<AdminBookingResponseDto>;
    total: number;
    limit: number;
    offset: number;
};

export type AdminBookingPostDto = {
    uuid: string;
    /**
     * Порядковый номер поста
     */
    orderNumber: number;
};

export type AdminBookingResponseDto = {
    uuid: string;
    client_uuid: string;
    car_uuid: {
        [key: string]: unknown;
    } | null;
    service_center_uuid: string;
    service_uuid: string;
    post_uuid: {
        [key: string]: unknown;
    } | null;
    start_time: string;
    end_time: string;
    status: string;
    total_cost: number;
    payment_status: string;
    payment_method: {
        [key: string]: unknown;
    } | null;
    /**
     * Источник создания бронирования: client_app (клиентское приложение) или admin_panel (панель администратора)
     */
    created_by_source: 'client_app' | 'admin_panel';
    client: AdminBookingClientDto;
    car: ((AdminBookingCarDto) | null);
    service: AdminBookingServiceDto;
    post: ((AdminBookingPostDto) | null);
    additionalServices?: Array<AdminBookingServiceDto>;
};

export namespace AdminBookingResponseDto {
    /**
     * Источник создания бронирования: client_app (клиентское приложение) или admin_panel (панель администратора)
     */
    export enum created_by_source {
        CLIENT_APP = 'client_app',
        ADMIN_PANEL = 'admin_panel'
    }
}

export type AdminBookingServiceDto = {
    uuid: string;
    name: string;
    duration_minutes: number;
    price: number;
};

export type AdminCarResponseDto = {
    /**
     * UUID автомобиля
     */
    uuid: string;
    /**
     * UUID клиента
     */
    client_uuid: string;
    /**
     * Номерной знак
     */
    license_plate: {
        [key: string]: unknown;
    };
    /**
     * Марка автомобиля
     */
    make: string;
    /**
     * Модель автомобиля
     */
    model: string;
    /**
     * Класс автомобиля
     */
    class: string;
    /**
     * Флаг создания нового автомобиля
     */
    created: boolean;
};

export type AdminCreateBookingDto = {
    /**
     * UUID сервисного центра
     */
    service_center_uuid: string;
    /**
     * UUID клиента
     */
    client_uuid: string;
    /**
     * UUID автомобиля
     */
    car_uuid?: string;
    /**
     * UUID основной услуги
     */
    service_uuid: string;
    /**
     * UUID поста сервисного центра (опционально, если не указан - будет найден первый доступный)
     */
    post_uuid?: string;
    /**
     * Время начала бронирования в формате ISO 8601 UTC
     */
    start_time: string;
    /**
     * Способ оплаты (не требуется для прошедших дат)
     */
    payment_method?: 'cash' | 'card' | 'sbp';
    /**
     * UUID дополнительных услуг
     */
    additional_service_uuids?: Array<string>;
    /**
     * Комментарий администратора
     */
    admin_comment?: string;
};

export namespace AdminCreateBookingDto {
    /**
     * Способ оплаты (не требуется для прошедших дат)
     */
    export enum payment_method {
        CASH = 'cash',
        CARD = 'card',
        SBP = 'sbp'
    }
}

export type AdminCreateBookingResponseDto = {
    /**
     * UUID бронирования
     */
    uuid: string;
    /**
     * UUID клиента
     */
    client_uuid: string;
    /**
     * UUID автомобиля
     */
    car_uuid: string;
    /**
     * UUID сервисного центра
     */
    service_center_uuid: string;
    /**
     * UUID основной услуги
     */
    service_uuid: string;
    /**
     * Время начала
     */
    start_time: string;
    /**
     * Время окончания
     */
    end_time: string;
    /**
     * Статус бронирования. Для будущих дат — pending_confirmation, для прошедших — completed
     */
    status: string;
    /**
     * Общая стоимость
     */
    total_cost: number;
    /**
     * Статус оплаты
     */
    payment_status: string;
    /**
     * Способ оплаты
     */
    payment_method: string;
    /**
     * Данные клиента
     */
    client: (AdminBookingClientDto);
    /**
     * Данные автомобиля
     */
    car: (AdminBookingCarDto);
    /**
     * Основная услуга
     */
    service: (AdminBookingServiceDto);
    /**
     * Дополнительные услуги
     */
    additionalServices: Array<AdminBookingServiceDto>;
};

export type AdminCreateOrUpdateCarDto = {
    /**
     * Номерной знак автомобиля
     */
    license_plate: string;
    /**
     * Марка автомобиля
     */
    make: string;
    /**
     * Модель автомобиля
     */
    model: string;
    /**
     * ID марки из справочника (опционально)
     */
    make_id?: string;
    /**
     * ID модели из справочника (опционально)
     */
    model_id?: string;
    /**
     * Цвет автомобиля
     */
    color?: string;
    /**
     * Класс автомобиля
     */
    class?: string;
};

export type AdminFindOrCreateClientDto = {
    /**
     * Телефон клиента в формате E.164 (+79991234567)
     */
    phone: string;
    /**
     * Имя клиента. При создании сохраняется сразу; для существующего клиента обновляет имя, если передано непустое значение.
     */
    name?: string;
};

export type AdminFindOrCreateClientResponseDto = {
    /**
     * UUID клиента
     */
    uuid: string;
    /**
     * Телефон клиента
     */
    phone: string;
    /**
     * Имя клиента
     */
    name: {
        [key: string]: unknown;
    } | null;
    /**
     * Email клиента
     */
    email: {
        [key: string]: unknown;
    } | null;
    /**
     * Флаг создания нового клиента
     */
    created: boolean;
};

export type AdminLoginDto = {
    /**
     * Номер телефона в формате +79991234567
     */
    phone: string;
    /**
     * 4-значный SMS код
     */
    code: string;
    /**
     * Контекст входа: superadmin — мастер-панель, service_center — админка сервисного центра. Должен совпадать с panel, переданным в send-code.
     */
    panel?: 'superadmin' | 'service_center';
};

export namespace AdminLoginDto {
    /**
     * Контекст входа: superadmin — мастер-панель, service_center — админка сервисного центра. Должен совпадать с panel, переданным в send-code.
     */
    export enum panel {
        SUPERADMIN = 'superadmin',
        SERVICE_CENTER = 'service_center'
    }
}

export type AdminSendCodeDto = {
    /**
     * Номер телефона в формате +79991234567
     */
    phone: string;
    /**
     * Контекст входа: superadmin — мастер-панель, service_center — админка сервисного центра. Если не указан: service_center при наличии привязки к СЦ, иначе superadmin.
     */
    panel?: 'superadmin' | 'service_center';
};

export namespace AdminSendCodeDto {
    /**
     * Контекст входа: superadmin — мастер-панель, service_center — админка сервисного центра. Если не указан: service_center при наличии привязки к СЦ, иначе superadmin.
     */
    export enum panel {
        SUPERADMIN = 'superadmin',
        SERVICE_CENTER = 'service_center'
    }
}

export type AdminSendCodeResponseDto = {
    success: boolean;
    message: string;
};

export type AdminUserDto = {
    uuid: string;
    email: string;
    name: string;
    phone: string;
    role: RoleResponseDto;
    /**
     * UUID сервисного центра. Заполняется при входе через panel=service_center, null для panel=superadmin.
     */
    service_center_uuid: string | null;
    /**
     * Контекст авторизации, в котором выдан токен
     */
    auth_panel: 'superadmin' | 'service_center';
    /**
     * true, если суперадмин авторизован в панели СЦ через impersonation
     */
    impersonation?: boolean;
    /**
     * Название СЦ при impersonation-сессии
     */
    impersonated_service_center_name?: string;
};

export namespace AdminUserDto {
    /**
     * Контекст авторизации, в котором выдан токен
     */
    export enum auth_panel {
        SUPERADMIN = 'superadmin',
        SERVICE_CENTER = 'service_center'
    }
}

export type AnalyticsLoadChartResponseDto = {
    /**
     * Данные для графика загрузки
     */
    load_data: Array<LoadDataPointDto>;
};

export type AnalyticsStatsResponseDto = {
    /**
     * Общее количество записей за период с процентом изменения
     */
    total_bookings: (StatsChangeDto);
    /**
     * Количество подтверждённых записей с процентом изменения
     */
    confirmed_bookings: (StatsChangeDto);
    /**
     * Количество не состоявшихся записей с процентом изменения
     */
    cancelled_bookings: (StatsChangeDto);
    /**
     * Общая выручка за период с процентом изменения
     */
    revenue: (StatsChangeDto);
};

export type AnalyticsTopServicesResponseDto = {
    /**
     * Список топовых услуг по количеству записей
     */
    top_services: Array<TopServiceDto>;
};

export type ApplyPaymentSchemeTemplateDto = {
    /**
     * null — отвязать шаблон («без шаблона»), ставки сотрудника остаются
     */
    template_uuid: (string) | null;
    /**
     * true — не трогать поля и строки, которые правили руками на карточке
     */
    keep_overrides?: boolean;
};

export type AuthResponseDto = {
    /**
     * Статус успешности операции
     */
    success: boolean;
    /**
     * Сообщение о результате операции
     */
    message: string;
    /**
     * JWT токен доступа
     */
    accessToken: string;
    /**
     * UUID проекта пользователя
     */
    projectUuid: string;
    /**
     * Информация о пользователе
     */
    user: (UserResponseDto);
};

export type AverageCheckStatsDto = {
    /**
     * Средний чек (руб.)
     */
    total: number;
    /**
     * Изменение относительно предыдущего года (%)
     */
    changePercent: number;
    /**
     * Разбивка по основным услугам
     */
    byService: Array<ServiceShareDto>;
};

export type BookingCarDto = {
    uuid: string;
    make: string;
    model: string;
};

export type BookingClientDto = {
    uuid: string;
    name: string;
    phone: string;
};

export type BookingDetailDto = {
    /**
     * UUID бронирования
     */
    uuid: string;
    /**
     * Клиент
     */
    client: (BookingClientDto);
    /**
     * Услуга
     */
    service: (BookingServiceDto);
    /**
     * Автомобиль
     */
    car: ((BookingCarDto) | null);
    /**
     * Время начала
     */
    startTime: string;
    /**
     * Время окончания
     */
    endTime: string;
    /**
     * Статус бронирования
     */
    status: string;
    /**
     * Статус оплаты
     */
    paymentStatus: {
        [key: string]: unknown;
    } | null;
    /**
     * Стоимость
     */
    totalCost: number;
};

export type BookingItemDto = {
    uuid: string;
    /**
     * Время начала
     */
    startTime: string;
    /**
     * Время окончания
     */
    endTime: string;
    client: BookingClientDto;
    service: BookingServiceDto;
    /**
     * Автомобиль клиента (может быть null)
     */
    car?: ((BookingCarDto) | null);
    /**
     * Итоговая стоимость (руб.)
     */
    totalCost: number;
    /**
     * Статус оплаты
     */
    paymentStatus: 'pending' | 'paid' | 'refunded' | 'partially_refunded';
    /**
     * Статус бронирования
     */
    status: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
    /**
     * Источник создания бронирования
     */
    source: 'client_app' | 'admin_panel';
    /**
     * UUID платежа (null если платёж не создан)
     */
    paymentUuid?: (string) | null;
};

export namespace BookingItemDto {
    /**
     * Статус оплаты
     */
    export enum paymentStatus {
        PENDING = 'pending',
        PAID = 'paid',
        REFUNDED = 'refunded',
        PARTIALLY_REFUNDED = 'partially_refunded'
    }
    /**
     * Статус бронирования
     */
    export enum status {
        PENDING = 'pending',
        CONFIRMED = 'confirmed',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    /**
     * Источник создания бронирования
     */
    export enum source {
        CLIENT_APP = 'client_app',
        ADMIN_PANEL = 'admin_panel'
    }
}

export type BookingPaymentResponseDto = {
    /**
     * UUID платежа
     */
    payment_uuid: string;
    /**
     * Статус платежа
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'partially_refunded' | 'refunded';
    /**
     * URL для оплаты (если есть)
     */
    payment_url: {
        [key: string]: unknown;
    } | null;
    /**
     * Сумма платежа
     */
    amount: number;
};

export namespace BookingPaymentResponseDto {
    /**
     * Статус платежа
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        PARTIALLY_REFUNDED = 'partially_refunded',
        REFUNDED = 'refunded'
    }
}

export type BookingResponseDto = {
    /**
     * Уникальный идентификатор бронирования
     */
    uuid: string;
    /**
     * Идентификатор клиента
     */
    client_uuid: string;
    /**
     * Идентификатор автомобиля
     */
    car_uuid: string;
    /**
     * Идентификатор сервисного центра
     */
    service_center_uuid: string;
    /**
     * Идентификатор услуги
     */
    service_uuid: string;
    /**
     * Идентификатор поста сервисного центра
     */
    post_uuid: {
        [key: string]: unknown;
    } | null;
    /**
     * Название сервисного центра
     */
    serviceCenterName: string;
    /**
     * Адрес сервисного центра
     */
    serviceCenterAddress: string;
    /**
     * Тип бизнеса сервисного центра
     */
    serviceBusinessType: 'tire_service' | 'car_wash';
    /**
     * Время начала бронирования
     */
    start_time: string;
    /**
     * Время окончания бронирования
     */
    end_time: string;
    /**
     * Статус бронирования
     */
    status: 'pending_confirmation' | 'confirmed' | 'completed' | 'cancelled';
    /**
     * Общая стоимость
     */
    total_cost: number;
    /**
     * Статус оплаты
     */
    payment_status: 'pending' | 'paid' | 'refund_pending';
    /**
     * Способ оплаты
     */
    payment_method: ('card' | 'sbp' | 'cash') | null;
    /**
     * Комментарий клиента
     */
    client_comment: {
        [key: string]: unknown;
    } | null;
    /**
     * Дата создания бронирования
     */
    created_at: string;
    /**
     * Дата последнего обновления
     */
    updated_at: string;
    /**
     * Источник создания бронирования
     */
    created_by_source: 'client_app' | 'admin_panel';
    /**
     * 4-значный код подтверждения визита. Возвращается только для грядущих бронирований
     */
    confirmation_code: {
        [key: string]: unknown;
    } | null;
    /**
     * Строка для QR: uuid бронирования и код подтверждения через двоеточие
     */
    qr_payload: {
        [key: string]: unknown;
    } | null;
};

export namespace BookingResponseDto {
    /**
     * Тип бизнеса сервисного центра
     */
    export enum serviceBusinessType {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
    /**
     * Статус бронирования
     */
    export enum status {
        PENDING_CONFIRMATION = 'pending_confirmation',
        CONFIRMED = 'confirmed',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    /**
     * Статус оплаты
     */
    export enum payment_status {
        PENDING = 'pending',
        PAID = 'paid',
        REFUND_PENDING = 'refund_pending'
    }
    /**
     * Способ оплаты
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp',
        CASH = 'cash'
    }
    /**
     * Источник создания бронирования
     */
    export enum created_by_source {
        CLIENT_APP = 'client_app',
        ADMIN_PANEL = 'admin_panel'
    }
}

export type BookingsBySourceDto = {
    /**
     * Бронирования через приложение
     */
    app: number;
    /**
     * Бронирования через админку
     */
    admin: number;
};

export type BookingServiceCenterDto = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
    /**
     * Название сервисного центра
     */
    name: string;
    /**
     * Адрес сервисного центра
     */
    address: string;
    /**
     * URL логотипа сервисного центра
     */
    logo_url: {
        [key: string]: unknown;
    } | null;
};

export type BookingServiceDto = {
    uuid: string;
    name: string;
};

export type BookingsListResponseDto = {
    data: Array<BookingItemDto>;
    meta: PaginationMetaDto;
};

export type BookingsStatsDto = {
    /**
     * Общее количество бронирований за год
     */
    total: number;
    /**
     * Изменение относительно предыдущего года (%)
     */
    changePercent: number;
    /**
     * Разбивка по источнику
     */
    bySource: (BookingsBySourceDto);
};

export type BulkGasStationScanDto = {
    /**
     * Код источника из gas_station_data_sources
     */
    source_code: string;
    /**
     * Время сканирования (ISO 8601)
     */
    scanned_at?: string;
    /**
     * Метаданные скана (bbox, file, url)
     */
    metadata?: {
        [key: string]: unknown;
    };
    items: Array<BulkGasStationScanItemDto>;
    /**
     * Не слать push-уведомления подписчикам (массовый автоимпорт)
     */
    skip_notifications?: boolean;
};

export type BulkGasStationScanErrorDto = {
    index: number;
    reason: string;
};

export type BulkGasStationScanItemDto = {
    /**
     * OSM ID заправки
     */
    osm_id?: string;
    /**
     * Идентификатор russiabase (poiid)
     */
    russian_base_id?: string;
    /**
     * UUID заправки в системе
     */
    gas_station_uuid?: string;
    status?: 'yes' | 'queue' | 'low' | 'no';
    /**
     * Размер очереди в минутах; null — очереди нет
     */
    queue_minutes?: {
        [key: string]: unknown;
    } | null;
    /**
     * Доступные виды топлива в формате gdebenz (92,95,ДТ)
     */
    fuels_now?: string;
    fuel_available?: FuelAvailabilityDto;
    detail?: {
        [key: string]: unknown;
    } | null;
    /**
     * Время наблюдения (ISO 8601)
     */
    observed_at?: string;
    /**
     * Сырой payload от источника
     */
    raw_payload?: {
        [key: string]: unknown;
    };
};

export namespace BulkGasStationScanItemDto {
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type BulkGasStationScanResponseDto = {
    scan_uuid: string;
    items_total: number;
    items_applied: number;
    items_skipped: number;
    errors: Array<BulkGasStationScanErrorDto>;
};

export type CampaignEventDto = {
    campaign_uuid: string;
    delivery_uuid?: string;
    event: 'opened' | 'stage';
    stage?: 'service_viewed' | 'slot_selected' | 'checkout_started' | 'booking_created' | 'booking_paid' | 'booking_completed';
    occurred_at: string;
};

export namespace CampaignEventDto {
    export enum event {
        OPENED = 'opened',
        STAGE = 'stage'
    }
    export enum stage {
        SERVICE_VIEWED = 'service_viewed',
        SLOT_SELECTED = 'slot_selected',
        CHECKOUT_STARTED = 'checkout_started',
        BOOKING_CREATED = 'booking_created',
        BOOKING_PAID = 'booking_paid',
        BOOKING_COMPLETED = 'booking_completed'
    }
}

export type CancelPaymentDto = {
    /**
     * Сумма возврата (если не указано - полный возврат, если указано - частичный)
     */
    amount?: number;
    /**
     * Причина возврата (вина платформы, вина контрагента, другое)
     */
    reason?: string;
};

export type CancelPaymentResponseDto = {
    /**
     * Статус платежа после операции отмены/возврата
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'partially_refunded' | 'refunded';
};

export namespace CancelPaymentResponseDto {
    /**
     * Статус платежа после операции отмены/возврата
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        PARTIALLY_REFUNDED = 'partially_refunded',
        REFUNDED = 'refunded'
    }
}

/**
 * Класс автомобиля (европейская классификация: A, B, C, D, E, F, J, M, S)
 */
export type CarEuropeanClass = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'J' | 'M' | 'S';

export type CarResponseDto = {
    /**
     * Уникальный идентификатор автомобиля
     */
    uuid: string;
    /**
     * Идентификатор владельца автомобиля
     */
    client_uuid: string;
    /**
     * Марка автомобиля
     */
    make: string;
    /**
     * Модель автомобиля
     */
    model: string;
    /**
     * Цвет автомобиля
     */
    color: (string) | null;
    /**
     * Размер шин
     */
    tire_size: (string) | null;
    /**
     * Класс автомобиля
     */
    class: string;
    /**
     * Упрощённый класс автомобиля для ценообразования
     */
    simple_car_class: 'sedan' | 'crossover' | 'suv' | 'minivan';
    /**
     * Номерной знак автомобиля
     */
    license_plate: {
        [key: string]: unknown;
    } | null;
    /**
     * Путь к сгенерированному изображению автомобиля
     */
    generated_image: (string) | null;
    /**
     * Дата создания записи
     */
    created_at: string;
    /**
     * Дата последнего обновления записи
     */
    updated_at: string;
};

export namespace CarResponseDto {
    /**
     * Упрощённый класс автомобиля для ценообразования
     */
    export enum simple_car_class {
        SEDAN = 'sedan',
        CROSSOVER = 'crossover',
        SUV = 'suv',
        MINIVAN = 'minivan'
    }
}

export type CarSearchResultDto = {
    /**
     * UUID автомобиля
     */
    uuid: string;
    /**
     * Номер автомобиля
     */
    license_plate: string;
    /**
     * Марка автомобиля
     */
    make: string;
    /**
     * Модель автомобиля
     */
    model: string;
    /**
     * Информация о владельце автомобиля
     */
    client: {
        [key: string]: unknown;
    };
};

export type CleanAddressDto = {
    /**
     * Массив строк с адресами для стандартизации
     */
    addresses: Array<string>;
};

export type ClientAppBookingsStatsDto = {
    /**
     * Процент бронирований через приложение за текущий год
     */
    current: number;
    /**
     * Изменение по сравнению с прошлым годом (%)
     */
    change_percent: number;
    /**
     * Количество бронирований через приложение
     */
    appCount: number;
    /**
     * Количество бронирований через админку
     */
    adminCount: number;
    /**
     * Помесячный процент бронирований через приложение
     */
    monthly: Array<number>;
};

export type ClientAuthResponseDto = {
    accessToken: string;
    refreshToken: string;
    client: ClientInfoDto;
};

export type ClientBookingCarDto = {
    uuid: string;
    make: string;
    model: string;
};

export type ClientBookingItemDto = {
    uuid: string;
    /**
     * Время начала
     */
    startTime: string;
    /**
     * Время окончания
     */
    endTime: string;
    /**
     * Услуга
     */
    service?: ((ClientBookingServiceDto) | null);
    /**
     * Автомобиль клиента
     */
    car?: ((ClientBookingCarDto) | null);
    /**
     * Итоговая стоимость (руб.)
     */
    totalCost: number;
    /**
     * Статус оплаты
     */
    paymentStatus: 'unpaid' | 'pending' | 'paid' | 'refunded' | 'partially_refunded';
    /**
     * Статус бронирования
     */
    status: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
    /**
     * Источник создания бронирования
     */
    source: 'client_app' | 'admin_panel';
    /**
     * UUID платежа
     */
    paymentUuid?: (string) | null;
    /**
     * Название сервисного центра
     */
    serviceCenterName?: (string) | null;
};

export namespace ClientBookingItemDto {
    /**
     * Статус оплаты
     */
    export enum paymentStatus {
        UNPAID = 'unpaid',
        PENDING = 'pending',
        PAID = 'paid',
        REFUNDED = 'refunded',
        PARTIALLY_REFUNDED = 'partially_refunded'
    }
    /**
     * Статус бронирования
     */
    export enum status {
        PENDING = 'pending',
        CONFIRMED = 'confirmed',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    /**
     * Источник создания бронирования
     */
    export enum source {
        CLIENT_APP = 'client_app',
        ADMIN_PANEL = 'admin_panel'
    }
}

export type ClientBookingServiceDto = {
    uuid: string;
    name: string;
};

export type ClientBookingsListResponseDto = {
    data: Array<ClientBookingItemDto>;
    meta: PaginationMetaDto;
};

export type ClientDetailCarDto = {
    uuid: string;
    make: string;
    model: string;
    /**
     * Год выпуска (может быть null)
     */
    year?: (number) | null;
    licensePlate: string;
};

export type ClientInfoDto = {
    uuid: string;
    phone: {
        [key: string]: unknown;
    } | null;
};

export type ClientLoginDto = {
    phone: string;
    code: string;
    /**
     * Уникальный идентификатор устройства
     */
    device_id?: string;
};

export type ClientResponseDto = {
    /**
     * Уникальный идентификатор клиента
     */
    uuid: string;
    /**
     * Имя клиента
     */
    name: {
        [key: string]: unknown;
    } | null;
    /**
     * Номер телефона клиента
     */
    phone: string;
    /**
     * Email адрес клиента
     */
    email: {
        [key: string]: unknown;
    } | null;
    /**
     * Настройки уведомлений клиента
     */
    notification_settings: {
        [key: string]: unknown;
    };
    /**
     * Дата создания записи
     */
    created_at: string;
    /**
     * Дата последнего обновления записи
     */
    updated_at: string;
};

export type ClientSearchResultDto = {
    /**
     * UUID клиента
     */
    uuid: string;
    /**
     * Номер телефона клиента
     */
    phone: string;
    /**
     * Имя клиента
     */
    name?: string;
};

export type ClientServiceCenterRefDto = {
    uuid: string;
    name: string;
};

export type ClientStatsBlockDto = {
    /**
     * Значение за текущий год
     */
    current: number;
    /**
     * Изменение по сравнению с прошлым годом (%)
     */
    change_percent: number;
    /**
     * Помесячные значения (12 элементов, по одному на каждый месяц)
     */
    monthly: Array<number>;
};

export type ClientStatsResponseDto = {
    /**
     * Блок «Бронирования»
     */
    bookings: (ClientStatsBlockDto);
    /**
     * Блок «% бронирований через приложение»
     */
    appBookingsPercent: (ClientAppBookingsStatsDto);
    /**
     * Блок «Расходы» (руб.)
     */
    spent: (ClientStatsBlockDto);
    /**
     * Блок «Комиссия» (руб.)
     */
    commission: (ClientStatsBlockDto);
};

export type ClientSummaryChartsDto = {
    /**
     * Данные графика «Всего бронирований»
     */
    totalBookings: Array<number>;
    /**
     * Человекочитаемые подписи для точек графика
     */
    labels: Array<string>;
};

export type ClientTransactionItemDto = {
    uuid: string;
    /**
     * Дата операции
     */
    date: string;
    /**
     * Тип операции
     */
    type: 'payment' | 'refund';
    /**
     * Описание операции
     */
    description: string;
    /**
     * Метод оплаты
     */
    paymentMethod?: ('card' | 'sbp' | 'cash') | null;
    /**
     * Сумма операции в копейках
     */
    amount: number;
    /**
     * Статус операции
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'refunded' | 'partially_refunded';
    /**
     * Отображаемый статус на русском
     */
    statusDisplay: string;
    /**
     * UUID связанного бронирования
     */
    bookingUuid?: (string) | null;
    /**
     * ID платежа в T-Bank
     */
    tbankPaymentId?: (string) | null;
    /**
     * ID заказа в T-Bank
     */
    tbankOrderId?: (string) | null;
    /**
     * Сообщение об ошибке (при failed)
     */
    errorMessage?: (string) | null;
    /**
     * Название сервисного центра
     */
    serviceCenterName?: (string) | null;
};

export namespace ClientTransactionItemDto {
    /**
     * Тип операции
     */
    export enum type {
        PAYMENT = 'payment',
        REFUND = 'refund'
    }
    /**
     * Метод оплаты
     */
    export enum paymentMethod {
        CARD = 'card',
        SBP = 'sbp',
        CASH = 'cash'
    }
    /**
     * Статус операции
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        REFUNDED = 'refunded',
        PARTIALLY_REFUNDED = 'partially_refunded'
    }
}

export type ClientTransactionsListResponseDto = {
    data: Array<ClientTransactionItemDto>;
    meta: PaginationMetaDto;
};

export type CommissionChartPointDto = {
    /**
     * Номер месяца (1-12)
     */
    month: number;
    /**
     * Короткое название месяца
     */
    label: string;
    /**
     * Комиссия за месяц (руб.)
     */
    value: number;
};

export type CommissionStatsDto = {
    /**
     * Общая комиссия за год (руб.)
     */
    total: number;
    /**
     * Изменение относительно предыдущего года (%)
     */
    changePercent: number;
    /**
     * Помесячный график комиссии
     */
    chart: Array<CommissionChartPointDto>;
};

export type ConfirmAccountDeletionByPhoneDto = {
    phone: string;
    /**
     * SMS код подтверждения
     */
    code: string;
};

export type ConfirmBookingDto = {
    /**
     * 4-значный код подтверждения бронирования
     */
    code: string;
};

export type ConfirmBookingResponseDto = {
    /**
     * UUID бронирования
     */
    uuid: string;
    /**
     * Статус бронирования после подтверждения
     */
    status: string;
    /**
     * Дата и время последнего обновления (ISO 8601)
     */
    updated_at: string;
};

export type ConfirmDeleteAccountDto = {
    /**
     * SMS код подтверждения удаления аккаунта
     */
    code: string;
};

export type ConflictingBookingDto = {
    /**
     * UUID бронирования
     */
    uuid: string;
    /**
     * Дата и время начала бронирования
     */
    start_time: string;
    /**
     * Дата и время окончания бронирования
     */
    end_time: string;
    /**
     * Статус бронирования
     */
    status: string;
    /**
     * Имя клиента
     */
    client_name?: string;
    /**
     * Телефон клиента
     */
    client_phone?: string;
    /**
     * Название услуги
     */
    service_name?: string;
};

export type CreateAdminDto = {
    /**
     * Email нового администратора
     */
    email: string;
    /**
     * Имя администратора
     */
    name: string;
    /**
     * Телефон администратора
     */
    phone: string;
    /**
     * Пароль для нового администратора
     */
    password: string;
};

export type CreateBookingDto = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    service_center_uuid: string;
    /**
     * Уникальный идентификатор услуги
     */
    service_uuid: string;
    /**
     * Уникальный идентификатор автомобиля клиента
     */
    car_uuid?: string;
    /**
     * Время начала бронирования в формате ISO8601 UTC
     */
    start_time: string;
    /**
     * Способ оплаты услуги
     */
    payment_method: 'card' | 'sbp' | 'cash';
    /**
     * Массив UUID дополнительных услуг
     */
    additionalServiceUuids?: Array<string>;
    /**
     * Комментарий клиента к бронированию
     */
    client_comment?: string;
};

export namespace CreateBookingDto {
    /**
     * Способ оплаты услуги
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp',
        CASH = 'cash'
    }
}

export type CreateCarDto = {
    /**
     * Марка автомобиля
     */
    make: string;
    /**
     * Модель автомобиля
     */
    model: string;
    /**
     * Цвет автомобиля
     */
    color?: string;
    /**
     * Размер шин
     */
    tire_size?: string;
    /**
     * Класс автомобиля (европейская классификация: A, B, C, D, E, F, J, M, S)
     */
    class?: (CarEuropeanClass);
    /**
     * Номерной знак автомобиля
     */
    license_plate?: string;
};

export type CreateDiscountDto = {
    title: string;
    description?: string;
    type: 'manual' | 'promocode';
    /**
     * Обязателен для type=promocode
     */
    promo_code?: string;
    value_type: 'percent' | 'fixed';
    /**
     * Для percent — целое 1..100; для fixed — сумма в копейках, >= 1
     */
    value: number;
    scope: 'all_centers' | 'selected_centers';
    audience: 'all' | 'selected_clients';
    platform_percent: number;
    sto_percent: number;
    starts_at?: string;
    ends_at?: string;
    is_active?: boolean;
    /**
     * Пусто — без лимита
     */
    max_uses_total?: number;
    /**
     * Пусто — без лимита
     */
    max_uses_per_client?: number;
    /**
     * При scope=selected_centers
     */
    service_center_uuids?: Array<string>;
    /**
     * При audience=selected_clients
     */
    client_uuids?: Array<string>;
    rules?: Array<DiscountRuleDto>;
};

export namespace CreateDiscountDto {
    export enum type {
        MANUAL = 'manual',
        PROMOCODE = 'promocode'
    }
    export enum value_type {
        PERCENT = 'percent',
        FIXED = 'fixed'
    }
    export enum scope {
        ALL_CENTERS = 'all_centers',
        SELECTED_CENTERS = 'selected_centers'
    }
    export enum audience {
        ALL = 'all',
        SELECTED_CLIENTS = 'selected_clients'
    }
}

export type CreateEmployeeDto = {
    service_center_uuid: string;
    first_name: string;
    last_name: string;
    phone: string;
    email?: (string) | null;
    position_uuid: string;
    is_active?: boolean;
    /**
     * Сразу привязать шаблон оплаты. null / не передано — без шаблона
     */
    template_uuid?: (string) | null;
};

export type CreateFaqDto = {
    /**
     * Вопрос
     */
    question: string;
    /**
     * Ответ
     */
    answer: string;
    /**
     * Порядок сортировки
     */
    sort_order?: number;
    /**
     * Активен ли вопрос
     */
    is_active?: boolean;
};

export type CreateFeedbackCommentDto = {
    /**
     * Текст комментария
     */
    text: string;
};

export type CreateGasStationDto = {
    /**
     * Цена газа в каталоге. null — цена неизвестна. Доступность — через fuel_available или null в price_*
     */
    price_gas?: (number) | null;
    /**
     * Цена ДТ в каталоге. null — цена неизвестна
     */
    price_dt?: (number) | null;
    /**
     * Цена АИ-92 в каталоге. null — цена неизвестна
     */
    price_ai_92?: (number) | null;
    /**
     * Цена АИ-95 в каталоге. null — цена неизвестна
     */
    price_ai_95?: (number) | null;
    /**
     * Цена АИ-95+ в каталоге. null — цена неизвестна
     */
    price_ai_95_plus?: (number) | null;
    /**
     * Цена АИ-98 в каталоге. null — цена неизвестна
     */
    price_ai_98?: (number) | null;
    /**
     * Цена АИ-100 в каталоге. null — цена неизвестна
     */
    price_ai_100?: (number) | null;
    /**
     * OSM ID или внешний идентификатор
     */
    osm_id?: string;
    /**
     * Бренд заправки
     */
    brand?: string;
    /**
     * Название заправки
     */
    name: string;
    /**
     * Адрес
     */
    address?: string;
    /**
     * Широта
     */
    lat: number;
    /**
     * Долгота
     */
    lon: number;
    /**
     * Статус
     */
    status?: 'yes' | 'queue' | 'low' | 'no';
    /**
     * Дополнительная информация
     */
    detail?: string;
    /**
     * Размер очереди в минутах. null — неизвестно
     */
    queue_minutes?: (number) | null;
    /**
     * Активна ли заправка
     */
    is_active?: boolean;
    /**
     * Лимит продажи бензина в одни руки, литры. null — без лимита/неизвестно
     */
    per_person_limit_liters_petrol?: (number) | null;
    /**
     * Лимит продажи дизеля в одни руки, литры. null — без лимита/неизвестно
     */
    per_person_limit_liters_dt?: (number) | null;
    /**
     * Доступность видов топлива (отдельно от каталога цен)
     */
    fuel_available?: (FuelAvailabilityDto);
    /**
     * Можно ли заливать в канистры
     */
    canister_refill_allowed?: boolean;
};

export namespace CreateGasStationDto {
    /**
     * Статус
     */
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type CreateHelpExecutorDto = {
    name: string;
    /**
     * Телефон исполнителя в формате E.164 (+79991234567)
     */
    phone: string;
    vehicle_model?: string;
    vehicle_plate?: string;
    experience_years?: number;
    company?: string;
    enabled?: boolean;
};

export type CreateHelpServiceDto = {
    kind: 'tow' | 'fuel' | 'jump_start' | 'addon';
    code: string;
    title: string;
    description: string;
    location_title?: (string) | null;
    unit_price: number;
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    pricing_mode: 'fixed' | 'per_unit' | 'flexible';
    /**
     * Внешний id услуги у провайдера (LAT service_id и аналоги).
     */
    provider_service_id?: (string) | null;
    unit_label?: string;
    sort_order?: number;
    enabled?: boolean;
    coming_soon?: boolean;
};

export namespace CreateHelpServiceDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start',
        ADDON = 'addon'
    }
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type CreatePaymentSchemeTemplateDto = {
    service_center_uuid: string;
    name: string;
    fix_per_shift?: (number) | null;
    hourly_rate?: (number) | null;
    services?: Array<PaymentSchemeServiceInputDto>;
};

export type CreatePostResponseDto = {
    /**
     * UUID созданного поста
     */
    uuid: string;
    /**
     * Порядковый номер поста
     */
    orderNumber: number;
    /**
     * Доступен ли пост для онлайн записи
     */
    isAvailableForOnlineBooking: boolean;
    /**
     * Дата создания
     */
    created_at: string;
};

export type CreateRoleDto = {
    [key: string]: unknown;
};

export type CreateServiceCenterDto = {
    /**
     * Название сервисного центра
     */
    name: string;
    /**
     * Адрес сервисного центра
     */
    address: string;
    /**
     * Координаты сервисного центра
     */
    location: (LocationDto);
    /**
     * Описание сервисного центра
     */
    description?: string;
    /**
     * URL логотипа
     */
    logo_url?: string;
    /**
     * Фотогалерея
     */
    photo_gallery_urls?: Array<string>;
    /**
     * Рабочие часы
     */
    working_hours: {
        [key: string]: unknown;
    };
    /**
     * Контакты
     */
    contacts: {
        [key: string]: unknown;
    };
    /**
     * Внешний рейтинг
     */
    external_rating?: number;
    /**
     * ИНН юрлица/ИП сервисного центра (10 или 12 цифр)
     */
    inn?: string;
    /**
     * Юридическое наименование сервисного центра
     */
    legal_name?: string;
};

export type CreateServiceDto = {
    /**
     * Название услуги
     */
    name: string;
    /**
     * Описание услуги
     */
    description?: string;
    /**
     * Длительность услуги в минутах
     */
    duration_minutes: number;
    /**
     * Категория услуги
     */
    category: string;
    /**
     * Тип бизнеса
     */
    business_type: 'tire_service' | 'car_wash';
    /**
     * Тип услуги
     */
    service_type: 'main' | 'additional';
    /**
     * Дополнительные заметки
     */
    notes?: string;
    /**
     * Массив цен для услуги
     */
    servicePrices: Array<CreateServicePriceDto>;
    /**
     * UUID сервисного центра
     */
    service_center_uuid: string;
};

export namespace CreateServiceDto {
    /**
     * Тип бизнеса
     */
    export enum business_type {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
    /**
     * Тип услуги
     */
    export enum service_type {
        MAIN = 'main',
        ADDITIONAL = 'additional'
    }
}

export type CreateServicePriceDto = {
    /**
     * Тип параметра ценообразования
     */
    parameter_type: 'simple_car_class' | 'wheel_size';
    /**
     * Значение параметра (sedan, crossover, suv, minivan, R13-R22)
     */
    parameter_value: string;
    /**
     * Цена услуги
     */
    price: number;
    /**
     * Активность цены
     */
    is_active: boolean;
};

export namespace CreateServicePriceDto {
    /**
     * Тип параметра ценообразования
     */
    export enum parameter_type {
        SIMPLE_CAR_CLASS = 'simple_car_class',
        WHEEL_SIZE = 'wheel_size'
    }
}

export type CreateSpecialDateDto = {
    /**
     * Специальная дата (праздник, выходной, сокращенный день)
     */
    specific_date: string;
    /**
     * Время открытия (формат HH:mm)
     */
    open_time?: string;
    /**
     * Время закрытия (формат HH:mm)
     */
    close_time?: string;
    /**
     * Флаг выходного дня
     */
    is_closed: boolean;
    /**
     * Часовой пояс
     */
    timezone?: string;
};

export type CreateTopicDto = {
    /**
     * Название темы
     */
    name: string;
    /**
     * Порядок сортировки
     */
    sort_order?: number;
    /**
     * Активна ли тема
     */
    is_active?: boolean;
};

export type CreateUserGasStationDto = {
    /**
     * Цена газа в каталоге. null — цена неизвестна. Доступность — через fuel_available или null в price_*
     */
    price_gas?: (number) | null;
    /**
     * Цена ДТ в каталоге. null — цена неизвестна
     */
    price_dt?: (number) | null;
    /**
     * Цена АИ-92 в каталоге. null — цена неизвестна
     */
    price_ai_92?: (number) | null;
    /**
     * Цена АИ-95 в каталоге. null — цена неизвестна
     */
    price_ai_95?: (number) | null;
    /**
     * Цена АИ-95+ в каталоге. null — цена неизвестна
     */
    price_ai_95_plus?: (number) | null;
    /**
     * Цена АИ-98 в каталоге. null — цена неизвестна
     */
    price_ai_98?: (number) | null;
    /**
     * Цена АИ-100 в каталоге. null — цена неизвестна
     */
    price_ai_100?: (number) | null;
    /**
     * Статус заправки
     */
    status?: 'yes' | 'queue' | 'low' | 'no';
    /**
     * Дополнительная информация
     */
    detail?: string;
    /**
     * Размер очереди в минутах. null — неизвестно
     */
    queue_minutes?: (number) | null;
    /**
     * Доступность видов топлива
     */
    fuel_available?: (FuelAvailabilityDto);
    /**
     * Бренд заправки
     */
    brand?: string;
    /**
     * Название заправки
     */
    name: string;
    /**
     * Адрес
     */
    address?: string;
    /**
     * Широта
     */
    lat: number;
    /**
     * Долгота
     */
    lon: number;
};

export namespace CreateUserGasStationDto {
    /**
     * Статус заправки
     */
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type DayScheduleDto = {
    /**
     * Время открытия (формат HH:mm)
     */
    open_time?: string;
    /**
     * Время закрытия (формат HH:mm)
     */
    close_time?: string;
    /**
     * Флаг выходного дня
     */
    is_closed: boolean;
};

export type DeletePostResponseDto = {
    /**
     * Результат удаления
     */
    success: boolean;
    /**
     * Сообщение
     */
    message: string;
};

export type DetailedBookingResponseDto = {
    /**
     * Уникальный идентификатор бронирования
     */
    uuid: string;
    /**
     * Идентификатор клиента
     */
    client_uuid: string;
    /**
     * Идентификатор автомобиля
     */
    car_uuid: string;
    /**
     * Идентификатор сервисного центра
     */
    service_center_uuid: string;
    /**
     * Идентификатор услуги
     */
    service_uuid: string;
    /**
     * Идентификатор поста сервисного центра
     */
    post_uuid: {
        [key: string]: unknown;
    } | null;
    /**
     * Название сервисного центра
     */
    serviceCenterName: string;
    /**
     * Адрес сервисного центра
     */
    serviceCenterAddress: string;
    /**
     * Тип бизнеса сервисного центра
     */
    serviceBusinessType: 'tire_service' | 'car_wash';
    /**
     * Время начала бронирования
     */
    start_time: string;
    /**
     * Время окончания бронирования
     */
    end_time: string;
    /**
     * Статус бронирования
     */
    status: 'pending_confirmation' | 'confirmed' | 'completed' | 'cancelled';
    /**
     * Общая стоимость
     */
    total_cost: number;
    /**
     * Статус оплаты
     */
    payment_status: 'pending' | 'paid' | 'refund_pending';
    /**
     * Способ оплаты
     */
    payment_method: ('card' | 'sbp' | 'cash') | null;
    /**
     * Комментарий клиента
     */
    client_comment: {
        [key: string]: unknown;
    } | null;
    /**
     * Дата создания бронирования
     */
    created_at: string;
    /**
     * Дата последнего обновления
     */
    updated_at: string;
    /**
     * Источник создания бронирования
     */
    created_by_source: 'client_app' | 'admin_panel';
    /**
     * 4-значный код подтверждения визита. Возвращается только для грядущих бронирований
     */
    confirmation_code: {
        [key: string]: unknown;
    } | null;
    /**
     * Строка для QR: uuid бронирования и код подтверждения через двоеточие
     */
    qr_payload: {
        [key: string]: unknown;
    } | null;
    /**
     * Информация о клиенте
     */
    client: (BookingClientDto);
    /**
     * Информация об автомобиле
     */
    car: (BookingCarDto);
    /**
     * Информация о сервисном центре
     */
    service_center: (BookingServiceCenterDto);
    /**
     * Информация об услуге
     */
    service: (BookingServiceDto);
    /**
     * Дополнительные услуги
     */
    additionalServices?: Array<BookingServiceDto>;
};

export namespace DetailedBookingResponseDto {
    /**
     * Тип бизнеса сервисного центра
     */
    export enum serviceBusinessType {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
    /**
     * Статус бронирования
     */
    export enum status {
        PENDING_CONFIRMATION = 'pending_confirmation',
        CONFIRMED = 'confirmed',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    /**
     * Статус оплаты
     */
    export enum payment_status {
        PENDING = 'pending',
        PAID = 'paid',
        REFUND_PENDING = 'refund_pending'
    }
    /**
     * Способ оплаты
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp',
        CASH = 'cash'
    }
    /**
     * Источник создания бронирования
     */
    export enum created_by_source {
        CLIENT_APP = 'client_app',
        ADMIN_PANEL = 'admin_panel'
    }
}

export type DetailedServiceCenterResponseDto = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
    /**
     * Название сервисного центра
     */
    name: string;
    /**
     * Адрес сервисного центра
     */
    address: string;
    /**
     * Местоположение сервисного центра
     */
    location: (ServiceCenterLocationDto);
    /**
     * Описание сервисного центра
     */
    description: {
        [key: string]: unknown;
    } | null;
    /**
     * URL логотипа сервисного центра
     */
    logo_url: {
        [key: string]: unknown;
    } | null;
    /**
     * URL фотографий галереи
     */
    photo_gallery_urls: Array<string>;
    /**
     * Часы работы по дням недели
     */
    working_hours: (ServiceCenterWorkingHoursDto);
    /**
     * Контактная информация
     */
    contacts: (ServiceCenterContactsDto);
    /**
     * Внешний рейтинг сервисного центра
     */
    external_rating: {
        [key: string]: unknown;
    } | null;
    /**
     * Находится ли сервисный центр в избранном у пользователя
     */
    isFavorite?: boolean;
    /**
     * Дата создания записи
     */
    created_at: string;
    /**
     * Дата последнего обновления записи
     */
    updated_at: string;
    /**
     * Все услуги сервисного центра (для обратной совместимости)
     */
    services: Array<ServiceDto>;
    /**
     * Основные услуги сервисного центра
     */
    mainServices: Array<ServiceDto>;
    /**
     * Дополнительные услуги сервисного центра
     */
    additionalServices: Array<ServiceDto>;
};

export type DiscountListResponseDto = {
    data: Array<DiscountResponseDto>;
    meta: {
        [key: string]: unknown;
    };
};

export type DiscountResponseDto = {
    uuid: string;
    title: string;
    description?: {
        [key: string]: unknown;
    } | null;
    type: 'manual' | 'promocode';
    promo_code?: {
        [key: string]: unknown;
    } | null;
    value_type: 'percent' | 'fixed';
    value: number;
    scope: 'all_centers' | 'selected_centers';
    audience: 'all' | 'selected_clients';
    platform_percent: number;
    sto_percent: number;
    starts_at?: (string) | null;
    ends_at?: (string) | null;
    is_active: boolean;
    max_uses_total?: {
        [key: string]: unknown;
    } | null;
    max_uses_per_client?: {
        [key: string]: unknown;
    } | null;
    created_at: string;
    updated_at: string;
    service_center_uuids: Array<string>;
    client_uuids: Array<string>;
    rules: Array<DiscountRuleResponseDto>;
};

export namespace DiscountResponseDto {
    export enum type {
        MANUAL = 'manual',
        PROMOCODE = 'promocode'
    }
    export enum value_type {
        PERCENT = 'percent',
        FIXED = 'fixed'
    }
    export enum scope {
        ALL_CENTERS = 'all_centers',
        SELECTED_CENTERS = 'selected_centers'
    }
    export enum audience {
        ALL = 'all',
        SELECTED_CLIENTS = 'selected_clients'
    }
}

export type DiscountRuleDto = {
    rule_type: 'min_order_sum' | 'specific_service' | 'first_order' | 'max_orders_count' | 'service_category';
    /**
     * Параметры правила (произвольный JSON-объект)
     */
    params: {
        [key: string]: unknown;
    };
};

export namespace DiscountRuleDto {
    export enum rule_type {
        MIN_ORDER_SUM = 'min_order_sum',
        SPECIFIC_SERVICE = 'specific_service',
        FIRST_ORDER = 'first_order',
        MAX_ORDERS_COUNT = 'max_orders_count',
        SERVICE_CATEGORY = 'service_category'
    }
}

export type DiscountRuleResponseDto = {
    uuid: string;
    rule_type: 'min_order_sum' | 'specific_service' | 'first_order' | 'max_orders_count' | 'service_category';
    params: {
        [key: string]: unknown;
    };
};

export namespace DiscountRuleResponseDto {
    export enum rule_type {
        MIN_ORDER_SUM = 'min_order_sum',
        SPECIFIC_SERVICE = 'specific_service',
        FIRST_ORDER = 'first_order',
        MAX_ORDERS_COUNT = 'max_orders_count',
        SERVICE_CATEGORY = 'service_category'
    }
}

export type DiscountUsageListResponseDto = {
    data: Array<DiscountUsageResponseDto>;
    meta: {
        [key: string]: unknown;
    };
};

export type DiscountUsageResponseDto = {
    uuid: string;
    discount_uuid: string;
    client_uuid: string;
    booking_uuid: string;
    applied_at: string;
    /**
     * Сумма скидки в копейках
     */
    discount_amount: number;
};

export type EmployeeDetailDto = {
    uuid: string;
    service_center_uuid: string;
    first_name: string;
    last_name: string;
    phone: string;
    email: (string) | null;
    position: EmployeePositionDto;
    is_active: boolean;
    template: EmployeeTemplateRefDto;
    created_at: string;
    updated_at: string;
    payment_scheme_uuid: string;
};

export type EmployeeListItemDto = {
    uuid: string;
    service_center_uuid: string;
    first_name: string;
    last_name: string;
    phone: string;
    email: (string) | null;
    position: EmployeePositionDto;
    is_active: boolean;
    template: EmployeeTemplateRefDto;
    created_at: string;
    updated_at: string;
};

export type EmployeeListResponseDto = {
    data: Array<EmployeeListItemDto>;
    total: number;
    limit: number;
    offset: number;
};

export type EmployeePositionDto = {
    uuid: string;
    key: string;
    name: string;
    is_system: boolean;
    sort_order: number;
};

export type EmployeePositionListResponseDto = {
    data: Array<EmployeePositionDto>;
};

export type EmployeeTemplateRefDto = {
    uuid: (string) | null;
    name: {
        [key: string]: unknown;
    } | null;
    /**
     * Шаблон меняли после последнего применения к этому сотруднику. Тултип в этой итерации не отдаём.
     */
    is_stale: boolean;
    /**
     * У сотрудника есть ручные ставки, которые пролив шаблона не затирает
     */
    has_overrides: boolean;
};

export type ErrorResponseDto = {
    /**
     * Статус успешности операции
     */
    success: boolean;
    /**
     * Информация об ошибке
     */
    error: {
        /**
         * Код ошибки
         */
        code?: string;
        /**
         * Сообщение об ошибке
         */
        message?: string;
        /**
         * Детали ошибки
         */
        details?: Array<string>;
    };
};

export type ExchangeImpersonationCodeDto = {
    /**
     * Одноразовый код impersonation-сессии
     */
    code: string;
};

export type FaqResponseDto = {
    /**
     * UUID вопроса
     */
    uuid: string;
    /**
     * Вопрос
     */
    question: string;
    /**
     * Ответ
     */
    answer: string;
    /**
     * Порядок сортировки
     */
    sort_order: number;
    /**
     * Активен ли вопрос
     */
    is_active: boolean;
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export type FeedbackDetailResponseDto = {
    /**
     * UUID обращения
     */
    uuid: string;
    /**
     * UUID темы обращения
     */
    topic_uuid?: (string) | null;
    /**
     * Название темы
     */
    topic_name?: (string) | null;
    /**
     * UUID клиента
     */
    client_uuid?: (string) | null;
    /**
     * Имя отправителя
     */
    name?: (string) | null;
    /**
     * Email для связи
     */
    email?: (string) | null;
    /**
     * Телефон клиента (если обращение от авторизованного клиента)
     */
    client_phone?: (string) | null;
    /**
     * Текст обращения
     */
    message: string;
    /**
     * Пути к прикрепленным файлам
     */
    files?: Array<string> | null;
    /**
     * Статус обращения
     */
    status: 'new' | 'in_progress' | 'resolved' | 'closed';
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
    /**
     * Хронология событий по заявке: смены статуса и комментарии, отсортированные по дате
     */
    timeline: Array<FeedbackTimelineEventDto>;
};

export namespace FeedbackDetailResponseDto {
    /**
     * Статус обращения
     */
    export enum status {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        RESOLVED = 'resolved',
        CLOSED = 'closed'
    }
}

export type FeedbackResponseDto = {
    /**
     * UUID обращения
     */
    uuid: string;
    /**
     * UUID темы обращения
     */
    topic_uuid?: (string) | null;
    /**
     * Название темы
     */
    topic_name?: (string) | null;
    /**
     * UUID клиента
     */
    client_uuid?: (string) | null;
    /**
     * Имя отправителя
     */
    name?: (string) | null;
    /**
     * Email для связи
     */
    email?: (string) | null;
    /**
     * Телефон клиента (если обращение от авторизованного клиента)
     */
    client_phone?: (string) | null;
    /**
     * Текст обращения
     */
    message: string;
    /**
     * Пути к прикрепленным файлам
     */
    files?: Array<string> | null;
    /**
     * Статус обращения
     */
    status: 'new' | 'in_progress' | 'resolved' | 'closed';
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export namespace FeedbackResponseDto {
    /**
     * Статус обращения
     */
    export enum status {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        RESOLVED = 'resolved',
        CLOSED = 'closed'
    }
}

export type FeedbackSettingsResponseDto = {
    /**
     * Email-адреса для уведомлений о новых обращениях
     */
    notification_emails: Array<string>;
    /**
     * Телефоны админов для push-уведомлений
     */
    push_phones: Array<string>;
    /**
     * Включена ли SMS-эскалация для необработанных обращений
     */
    sms_escalation_enabled: boolean;
    /**
     * Задержка перед SMS-эскалацией (минуты)
     */
    sms_escalation_delay_minutes: number;
    /**
     * Телефоны для SMS-эскалации
     */
    sms_escalation_phones: Array<string>;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export type FeedbackTimelineEventDto = {
    /**
     * UUID события
     */
    uuid: string;
    /**
     * Тип события
     */
    type: 'status_change' | 'comment';
    /**
     * Дата и время события
     */
    created_at: string;
    /**
     * UUID автора (администратора)
     */
    author_uuid?: (string) | null;
    /**
     * Имя автора
     */
    author_name?: (string) | null;
    /**
     * Предыдущий статус (только для status_change)
     */
    old_status?: ('new' | 'in_progress' | 'resolved' | 'closed') | null;
    /**
     * Новый статус (только для status_change)
     */
    new_status?: 'new' | 'in_progress' | 'resolved' | 'closed';
    /**
     * Текст комментария (только для comment)
     */
    text?: string;
};

export namespace FeedbackTimelineEventDto {
    /**
     * Тип события
     */
    export enum type {
        STATUS_CHANGE = 'status_change',
        COMMENT = 'comment'
    }
    /**
     * Предыдущий статус (только для status_change)
     */
    export enum old_status {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        RESOLVED = 'resolved',
        CLOSED = 'closed'
    }
    /**
     * Новый статус (только для status_change)
     */
    export enum new_status {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        RESOLVED = 'resolved',
        CLOSED = 'closed'
    }
}

export type FindBankDto = {
    /**
     * БИК или название банка
     */
    query: string;
};

export type FindPartyDto = {
    /**
     * ИНН или ОГРН организации
     */
    query: string;
};

export type FuelAvailabilityDto = {
    price_gas?: boolean;
    price_dt?: boolean;
    price_ai_92?: boolean;
    price_ai_95?: boolean;
    price_ai_95_plus?: boolean;
    price_ai_98?: boolean;
    price_ai_100?: boolean;
};

export type GasStationFuelAvailabilityResponseDto = {
    price_gas: boolean;
    price_dt: boolean;
    price_ai_92: boolean;
    price_ai_95: boolean;
    price_ai_95_plus: boolean;
    price_ai_98: boolean;
    price_ai_100: boolean;
};

export type GasStationFuelCatalogResponseDto = {
    price_gas?: (number) | null;
    price_dt?: (number) | null;
    price_ai_92?: (number) | null;
    price_ai_95?: (number) | null;
    price_ai_95_plus?: (number) | null;
    price_ai_98?: (number) | null;
    price_ai_100?: (number) | null;
};

export type GasStationListItemDto = {
    uuid: string;
    lat: number;
    lon: number;
    name: string;
    status: 'yes' | 'queue' | 'low' | 'no';
    price_gas?: (number) | null;
    price_dt?: (number) | null;
    price_ai_92?: (number) | null;
    price_ai_95?: (number) | null;
    price_ai_95_plus?: (number) | null;
    price_ai_98?: (number) | null;
    price_ai_100?: (number) | null;
    /**
     * Доступные виды топлива (через запятую)
     */
    fuels_now: string;
    /**
     * Общая агрегированная достоверность операционных данных (0..1)
     */
    confidence_base: number;
    /**
     * Доступность топлива по видам. Используется для согласованной фильтрации карты с кластерами.
     */
    fuel_available?: ((GasStationFuelAvailabilityResponseDto) | null);
};

export namespace GasStationListItemDto {
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type GasStationMapClusterItemDto = {
    type: 'cluster';
    /**
     * Идентификатор кластера (cluster:<id>)
     */
    id: string;
    lat: number;
    lon: number;
    /**
     * Количество АЗС в кластере
     */
    count: number;
};

export namespace GasStationMapClusterItemDto {
    export enum type {
        CLUSTER = 'cluster'
    }
}

export type GasStationMapPointItemDto = {
    uuid: string;
    lat: number;
    lon: number;
    name: string;
    status: 'yes' | 'queue' | 'low' | 'no';
    price_gas?: (number) | null;
    price_dt?: (number) | null;
    price_ai_92?: (number) | null;
    price_ai_95?: (number) | null;
    price_ai_95_plus?: (number) | null;
    price_ai_98?: (number) | null;
    price_ai_100?: (number) | null;
    /**
     * Доступные виды топлива (через запятую)
     */
    fuels_now: string;
    /**
     * Общая агрегированная достоверность операционных данных (0..1)
     */
    confidence_base: number;
    /**
     * Доступность топлива по видам. Используется для согласованной фильтрации карты с кластерами.
     */
    fuel_available?: ((GasStationFuelAvailabilityResponseDto) | null);
    type: 'point';
};

export namespace GasStationMapPointItemDto {
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
    export enum type {
        POINT = 'point'
    }
}

export type GasStationReportResponseDto = {
    price_gas?: (number) | null;
    price_dt?: (number) | null;
    price_ai_92?: (number) | null;
    price_ai_95?: (number) | null;
    price_ai_95_plus?: (number) | null;
    price_ai_98?: (number) | null;
    price_ai_100?: (number) | null;
    uuid: string;
    source: 'user' | 'admin' | 'import';
    status: 'yes' | 'queue' | 'low' | 'no';
    detail?: {
        [key: string]: unknown;
    } | null;
    /**
     * Размер очереди в минутах
     */
    queue_minutes?: (number) | null;
    client_uuid?: {
        [key: string]: unknown;
    } | null;
    admin_uuid?: {
        [key: string]: unknown;
    } | null;
    /**
     * Доступность видов топлива в отчёте
     */
    fuel_available?: ((GasStationFuelAvailabilityResponseDto) | null);
    created_at: string;
    /**
     * Сколько часов назад был создан отчёт
     */
    hours_ago: number;
};

export namespace GasStationReportResponseDto {
    export enum source {
        USER = 'user',
        ADMIN = 'admin',
        IMPORT = 'import'
    }
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type GasStationResponseDto = {
    price_gas?: (number) | null;
    price_dt?: (number) | null;
    price_ai_92?: (number) | null;
    price_ai_95?: (number) | null;
    price_ai_95_plus?: (number) | null;
    price_ai_98?: (number) | null;
    price_ai_100?: (number) | null;
    uuid: string;
    osm_id?: {
        [key: string]: unknown;
    } | null;
    /**
     * Идентификатор заправки в russiabase.ru (poiid)
     */
    russian_base_id?: {
        [key: string]: unknown;
    } | null;
    brand?: {
        [key: string]: unknown;
    } | null;
    name: string;
    address: string;
    lat: number;
    lon: number;
    status: 'yes' | 'queue' | 'low' | 'no';
    detail?: {
        [key: string]: unknown;
    } | null;
    /**
     * Размер очереди в минутах
     */
    queue_minutes?: (number) | null;
    /**
     * Каталог цен (источник russiabase и др.)
     */
    fuel_prices: (GasStationFuelCatalogResponseDto);
    /**
     * Доступность видов топлива
     */
    fuel_available: (GasStationFuelAvailabilityResponseDto);
    /**
     * Доступные виды топлива (через запятую)
     */
    fuels_now: string;
    confirmations: number;
    confirmed: boolean;
    last_at?: {
        [key: string]: unknown;
    } | null;
    /**
     * Общая агрегированная достоверность операционных данных (0..1): среднее status/queue/fuel confidence по полям с сигналом
     */
    confidence_base: number;
    /**
     * Достоверность текущего status (0..1): доля согласия × доверие к источнику
     */
    status_confidence: number;
    /**
     * Достоверность данных об очереди (0..1)
     */
    queue_confidence: number;
    /**
     * Заполненность операционных полей (0..1)
     */
    data_completeness: number;
    /**
     * Время последнего скан-наблюдения
     */
    last_scan_at?: {
        [key: string]: unknown;
    } | null;
    /**
     * Достоверность per-fuel из скан-наблюдений
     */
    fuel_confidence?: {
        [key: string]: unknown;
    } | null;
    /**
     * Лимит продажи бензина в одни руки, литры
     */
    per_person_limit_liters_petrol?: (number) | null;
    /**
     * Лимит продажи дизеля в одни руки, литры
     */
    per_person_limit_liters_dt?: (number) | null;
    /**
     * Можно ли заливать в канистры
     */
    canister_refill_allowed: boolean;
    /**
     * В избранном у текущего пользователя
     */
    isFavorite?: boolean;
    /**
     * Подписка на виды топлива у текущего пользователя
     */
    subscribed_fuels?: Array<string> | null;
    /**
     * Флаг «только один раз» у подписки текущего пользователя на эту АЗС
     */
    subscription_notify_once?: {
        [key: string]: unknown;
    } | null;
    /**
     * Расстояние в км
     */
    distance_km?: number;
};

export namespace GasStationResponseDto {
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type GasStationsListResponseDto = {
    stations: Array<GasStationListItemDto>;
    meta?: PaginationMetaDto;
};

export type GasStationsMapMetaDto = {
    point_count: number;
    cluster_count: number;
};

export type GasStationsMapResponseDto = {
    mode: 'clustered' | 'points';
    items: Array<(GasStationMapClusterItemDto | GasStationMapPointItemDto)>;
    meta: GasStationsMapMetaDto;
};

export namespace GasStationsMapResponseDto {
    export enum mode {
        CLUSTERED = 'clustered',
        POINTS = 'points'
    }
}

export type GasStationSubscriptionResponseDto = {
    uuid: string;
    gas_station_uuid: string;
    gas_station_name: string;
    watch_fuels: Array<string>;
    /**
     * Уведомить только один раз: после первого уведомления подписка автоматически удаляется
     */
    notify_once: boolean;
    created_at: string;
    updated_at: string;
};

export type GroupedResponseDto = {
    /**
     * Поля группировки
     */
    groupBy: Array<string>;
    /**
     * Запрошенные метрики
     */
    metrics: Array<string>;
    /**
     * Группы с метриками
     */
    groups: Array<GroupedRowDto>;
    /**
     * Итоговые метрики по всему набору данных
     */
    totals: {
        [key: string]: unknown;
    };
};

export type GroupedRowDto = {
    /**
     * Значения измерений группировки
     */
    keys: {
        [key: string]: unknown;
    };
    /**
     * Агрегированные метрики группы
     */
    metrics: {
        [key: string]: unknown;
    };
};

export type HelpActiveOrderResponseDto = {
    order?: ((HelpOrderDto) | null);
};

export type HelpClientServiceDto = {
    uuid: string;
    kind: 'tow' | 'fuel' | 'jump_start';
    code: string;
    title: string;
    description: string;
    location_title?: (string) | null;
    price_from: number;
    coming_soon: boolean;
};

export namespace HelpClientServiceDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
}

export type HelpExecutorAdminDto = {
    uuid: string;
    name: string;
    phone: string;
    vehicle_model: string;
    vehicle_plate: string;
    experience_years: number;
    company: string;
    enabled: boolean;
    created_at: string;
    updated_at: string;
};

export type HelpExecutorSnapshotDto = {
    uuid?: (string) | null;
    name: string;
    phone: string;
    vehicle_model: string;
    vehicle_plate: string;
    experience_years: number;
    company: string;
    /**
     * Широта snapshot-положения исполнителя на заявке
     */
    lat?: (number) | null;
    /**
     * Долгота snapshot-положения исполнителя на заявке
     */
    lon?: (number) | null;
    eta_minutes?: (number) | null;
};

export type HelpOrderCommentDto = {
    text: string;
};

export type HelpOrderCustomerPatchDto = {
    client_name?: string;
    client_phone?: string;
    vehicle_make_model?: string;
    vehicle_reg_number?: string;
    vehicle_vin?: (string) | null;
    vehicle_year?: (string) | null;
};

export type HelpOrderDto = {
    uuid: string;
    status: 'awaiting_confirmation' | 'en_route' | 'on_site' | 'in_progress' | 'completed' | 'cancelled';
    kind: 'tow' | 'fuel' | 'jump_start';
    client_name: string;
    client_phone: string;
    vehicle_make_model: string;
    vehicle_reg_number: string;
    vehicle_vin?: (string) | null;
    vehicle_year?: (string) | null;
    pickup: HelpPointDto;
    dropoff?: ((HelpPointDto) | null);
    blocked_wheels: number;
    hard_to_access: boolean;
    comment?: (string) | null;
    files: Array<string>;
    items: Array<HelpOrderItemDto>;
    prepaid_amount: number;
    prepaid_status: 'pending' | 'success' | 'refunded';
    extra_amount: number;
    extra_payment_status: 'pending' | 'success' | 'refunded';
    total_amount: number;
    executor?: ((HelpExecutorSnapshotDto) | null);
    events: Array<HelpOrderEventDto>;
    created_at: string;
    updated_at: string;
};

export namespace HelpOrderDto {
    export enum status {
        AWAITING_CONFIRMATION = 'awaiting_confirmation',
        EN_ROUTE = 'en_route',
        ON_SITE = 'on_site',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
    export enum prepaid_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
    export enum extra_payment_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
}

export type HelpOrderEventDto = {
    uuid: string;
    type: 'system' | 'status' | 'comment' | 'notify' | 'executor';
    title: string;
    detail?: (string) | null;
    created_at: string;
};

export namespace HelpOrderEventDto {
    export enum type {
        SYSTEM = 'system',
        STATUS = 'status',
        COMMENT = 'comment',
        NOTIFY = 'notify',
        EXECUTOR = 'executor'
    }
}

export type HelpOrderExecutorPatchDto = {
    catalog_uuid?: (string) | null;
    name?: string;
    /**
     * Телефон исполнителя в формате E.164 (+79991234567)
     */
    phone?: string;
    vehicle_model?: string;
    vehicle_plate?: string;
    experience_years?: number;
    company?: string;
    /**
     * Широта snapshot-положения исполнителя. Передаётся только вместе с lon: оба числа или оба null.
     */
    lat?: (number) | null;
    /**
     * Долгота snapshot-положения исполнителя. Передаётся только вместе с lat: оба числа или оба null.
     */
    lon?: (number) | null;
    eta_minutes?: (number) | null;
};

export type HelpOrderItemDto = {
    uuid: string;
    service_uuid?: (string) | null;
    code: string;
    title: string;
    quantity: number;
    unit_price: number;
    pricing_mode: 'fixed' | 'per_unit' | 'flexible';
    amount: number;
};

export namespace HelpOrderItemDto {
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type HelpOrderItemPatchDto = {
    service_uuid?: string;
    code: string;
    title: string;
    quantity: number;
    unit_price: number;
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    pricing_mode: 'fixed' | 'per_unit' | 'flexible';
};

export namespace HelpOrderItemPatchDto {
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type HelpOrderNotifyDto = {
    text: string;
};

export type HelpOrdersMetricsDto = {
    active: number;
    awaiting_dispatcher: number;
    prepaid_sum: number;
};

export type HelpPointDto = {
    city?: string;
    address: string;
    lat: number;
    lon: number;
    note?: string;
};

export type HelpQuoteLineDto = {
    service_uuid: string;
    code: string;
    title: string;
    quantity: number;
    unit_price: number;
    pricing_mode: 'fixed' | 'per_unit' | 'flexible';
    amount: number;
    extra: boolean;
};

export namespace HelpQuoteLineDto {
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type HelpQuoteRequestDto = {
    kind: 'tow' | 'fuel' | 'jump_start';
    blocked_wheels?: number;
    hard_to_access?: boolean;
    car_uuid?: string;
};

export namespace HelpQuoteRequestDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
}

export type HelpQuoteResponseDto = {
    kind: 'tow' | 'fuel' | 'jump_start';
    lines: Array<HelpQuoteLineDto>;
    prepaid_amount: number;
    extra_amount: number;
    total_amount: number;
};

export namespace HelpQuoteResponseDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
}

export type HelpServiceAdminDto = {
    uuid: string;
    kind: 'tow' | 'fuel' | 'jump_start' | 'addon';
    code: string;
    title: string;
    description: string;
    location_title?: (string) | null;
    unit_price: number;
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    pricing_mode: 'fixed' | 'per_unit' | 'flexible';
    /**
     * Внешний id услуги у провайдера (LAT service_id и аналоги).
     */
    provider_service_id?: (string) | null;
    unit_label: string;
    sort_order: number;
    enabled: boolean;
    coming_soon: boolean;
    created_at: string;
    updated_at: string;
};

export namespace HelpServiceAdminDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start',
        ADDON = 'addon'
    }
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type ImpersonationCodeResponseDto = {
    /**
     * Одноразовый код для обмена на токены в service-admin
     */
    code: string;
    /**
     * Время жизни кода в секундах
     */
    expiresIn: number;
};

export type InitPaymentDto = {
    /**
     * UUID бронирования
     */
    booking_uuid: string;
    /**
     * Метод оплаты
     */
    payment_method: 'card' | 'sbp';
};

export namespace InitPaymentDto {
    /**
     * Метод оплаты
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp'
    }
}

export type InitPaymentResponseDto = {
    /**
     * UUID платежа
     */
    payment_uuid: string;
    /**
     * URL для оплаты (для card) или QR-код (для sbp)
     */
    payment_url: string;
    /**
     * Время истечения платежа
     */
    expires_at: string;
};

export type LegalDataResponseDto = {
    /**
     * UUID сервисного центра
     */
    uuid: string;
    /**
     * Краткое название магазина в СМС и на 3DS-форме (1–14 символов, только латиница, цифры, . - _ пробел).
     */
    billing_descriptor: (string) | null;
    /**
     * Полное юридическое наименование организации с ОПФ.
     */
    legal_full_name: (string) | null;
    /**
     * Сокращённое наименование организации с ОПФ.
     */
    legal_name: (string) | null;
    /**
     * ИНН (10 цифр для ЮЛ, 12 для ИП).
     */
    inn: (string) | null;
    /**
     * КПП (9 цифр). Для ИП — 000000000.
     */
    kpp: (string) | null;
    /**
     * ОГРН: 13 цифр для ЮЛ, 15 для ИП.
     */
    ogrn: (string) | null;
    /**
     * Email организации.
     */
    legal_email: (string) | null;
    /**
     * Адрес сайта организации.
     */
    site_url: (string) | null;
    /**
     * Почтовый индекс (6 цифр).
     */
    legal_zip: (string) | null;
    /**
     * Код страны ISO 3166 Alpha-3.
     */
    legal_country: (string) | null;
    /**
     * Город юридического адреса.
     */
    legal_city: (string) | null;
    /**
     * Улица и дом юридического адреса.
     */
    legal_street: (string) | null;
    /**
     * Имя руководителя.
     */
    director_first_name: (string) | null;
    /**
     * Фамилия руководителя.
     */
    director_last_name: (string) | null;
    /**
     * Отчество руководителя.
     */
    director_middle_name: (string) | null;
    /**
     * Телефон руководителя (+79XXXXXXXXX).
     */
    director_phone: (string) | null;
    /**
     * Гражданство руководителя — ISO 3166 Alpha-3.
     */
    director_citizenship: (string) | null;
    /**
     * Расчётный счёт (20 цифр).
     */
    settlement_account: (string) | null;
    /**
     * Корреспондентский счёт (20 цифр).
     */
    correspondent_account: (string) | null;
    /**
     * Полное наименование банка.
     */
    bank_name: (string) | null;
    /**
     * БИК банка (9 цифр).
     */
    bik: (string) | null;
    /**
     * Назначение платежа при перечислении возмещения.
     */
    bank_payment_details: (string) | null;
    /**
     * Номер договора с оператором сервиса.
     */
    contract_number: (string) | null;
    /**
     * Дата заключения договора (YYYY-MM-DD).
     */
    contract_date: (string) | null;
    /**
     * Номер кабинета / офиса.
     */
    office: (string) | null;
    /**
     * Организационно-правовая форма (ОПФ).
     */
    orgForm: (string) | null;
    /**
     * Все обязательные поля для T-Bank заполнены.
     */
    isLegalDataFilled: boolean;
    /**
     * Внутренний числовой ID точки в T-Bank (shopCode). Появляется после успешной регистрации.
     */
    tbank_shop_code: (string) | null;
    /**
     * Идентификатор магазина партнёра в T-Bank (shopArticleId / code). Появляется после успешной регистрации.
     */
    tbank_shop_article_id: (string) | null;
    /**
     * Дата и время успешной регистрации в T-Bank.
     */
    tbank_registered_at: (string) | null;
};

export type ListResponseDto = {
    /**
     * Массив данных
     */
    data: Array<unknown[]>;
    /**
     * Метаданные пагинации
     */
    meta: (PaginationMetaDto);
};

export type LoadDataPointDto = {
    /**
     * Метка данных (день недели для week: 'Пн', 'Вт'... или час для day: '0', '1'...)
     */
    label: string;
    /**
     * Количество записей в этот период
     */
    bookings_count: number;
};

export type LocationDto = {
    /**
     * Широта
     */
    lat: number;
    /**
     * Долгота
     */
    lon: number;
};

export type LoginDto = {
    /**
     * Email пользователя
     */
    email: string;
    /**
     * Пароль пользователя
     */
    password: string;
};

export type LogoutResponseDto = {
    /**
     * Статус успешности операции
     */
    success: boolean;
    /**
     * Сообщение о результате операции
     */
    message: string;
};

export type NotificationResponseDto = {
    /**
     * UUID уведомления
     */
    uuid: string;
    /**
     * UUID пользователя
     */
    userUuid: string;
    /**
     * Тип пользователя
     */
    userType: 'admin' | 'client';
    /**
     * Заголовок уведомления
     */
    title: string;
    /**
     * Подзаголовок уведомления
     */
    subtitle: (string) | null;
    /**
     * Текст уведомления
     */
    body: string;
    /**
     * Тип уведомления
     */
    type: 'new_booking' | 'booking_cancelled' | 'status_change' | 'booking_updated' | 'feedback' | 'gas_station_fuel_available' | 'promotion';
    /**
     * Ссылка на событие
     */
    link: {
        [key: string]: unknown;
    } | null;
    /**
     * Дополнительные данные
     */
    data: {
        [key: string]: unknown;
    } | null;
    /**
     * Прочитано ли уведомление
     */
    isRead: boolean;
    /**
     * Дата прочтения
     */
    readAt: {
        [key: string]: unknown;
    } | null;
    /**
     * Дата создания
     */
    createdAt: string;
};

export namespace NotificationResponseDto {
    /**
     * Тип пользователя
     */
    export enum userType {
        ADMIN = 'admin',
        CLIENT = 'client'
    }
    /**
     * Тип уведомления
     */
    export enum type {
        NEW_BOOKING = 'new_booking',
        BOOKING_CANCELLED = 'booking_cancelled',
        STATUS_CHANGE = 'status_change',
        BOOKING_UPDATED = 'booking_updated',
        FEEDBACK = 'feedback',
        GAS_STATION_FUEL_AVAILABLE = 'gas_station_fuel_available',
        PROMOTION = 'promotion'
    }
}

export type NotificationSettingsDto = {
    /**
     * Получать push-уведомления о новых заказах
     */
    newBooking?: boolean;
    /**
     * Получать push-уведомления об изменении статуса заказа
     */
    statusChange?: boolean;
    /**
     * Получать push-уведомления о напоминаниях
     */
    reminders?: boolean;
    /**
     * Получать push-уведомления о промо-акциях
     */
    promotions?: boolean;
};

export type NotificationsListResponseDto = {
    items: Array<NotificationResponseDto>;
    /**
     * Общее количество уведомлений
     */
    total: number;
    /**
     * Текущая страница
     */
    page: number;
    /**
     * Количество элементов на странице
     */
    limit: number;
    /**
     * Всего страниц
     */
    totalPages: number;
};

export type OperatingHoursListResponseDto = {
    /**
     * Регулярное расписание (по дням недели)
     */
    regular: Array<OperatingHoursResponseDto>;
    /**
     * Специальные даты (праздники, выходные)
     */
    special: Array<OperatingHoursResponseDto>;
};

export type OperatingHoursResponseDto = {
    /**
     * UUID записи
     */
    uuid: string;
    /**
     * UUID сервисного центра
     */
    service_center_uuid: string;
    /**
     * День недели (для регулярного расписания)
     */
    day_of_week?: ('monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday') | null;
    /**
     * Специальная дата (для праздников/выходных)
     */
    specific_date?: (string) | null;
    /**
     * Время открытия (формат HH:mm)
     */
    open_time?: {
        [key: string]: unknown;
    } | null;
    /**
     * Время закрытия (формат HH:mm)
     */
    close_time?: {
        [key: string]: unknown;
    } | null;
    /**
     * Флаг выходного дня
     */
    is_closed: boolean;
    /**
     * Часовой пояс
     */
    timezone: string;
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export namespace OperatingHoursResponseDto {
    /**
     * День недели (для регулярного расписания)
     */
    export enum day_of_week {
        MONDAY = 'monday',
        TUESDAY = 'tuesday',
        WEDNESDAY = 'wednesday',
        THURSDAY = 'thursday',
        FRIDAY = 'friday',
        SATURDAY = 'saturday',
        SUNDAY = 'sunday'
    }
}

export type PaginationMetaDto = {
    /**
     * Текущая страница
     */
    page: number;
    /**
     * Количество элементов на странице
     */
    limit: number;
    /**
     * Общее количество элементов
     */
    total: number;
    /**
     * Общее количество страниц
     */
    totalPages: number;
    /**
     * Есть ли следующая страница
     */
    hasNextPage: boolean;
    /**
     * Есть ли предыдущая страница
     */
    hasPrevPage: boolean;
};

export type PaymentDetailDto = {
    /**
     * UUID платежа
     */
    uuid: string;
    /**
     * Сумма платежа в копейках
     */
    amount: number;
    /**
     * Валюта
     */
    currency: string;
    /**
     * Метод оплаты
     */
    paymentMethod: 'card' | 'sbp' | 'acquiring';
    /**
     * Статус платежа
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'partially_refunded' | 'refunded';
    /**
     * ID платежа в T-Bank
     */
    tbankPaymentId: (string) | null;
    /**
     * ID заказа в T-Bank
     */
    tbankOrderId: (string) | null;
    /**
     * ID сделки в T-Bank
     */
    tbankDealId: (string) | null;
    /**
     * Дата оплаты
     */
    paidAt: (string) | null;
    /**
     * Дата подтверждения
     */
    confirmedAt: (string) | null;
    /**
     * Дата создания
     */
    createdAt: string;
    /**
     * Сообщение об ошибке
     */
    errorMessage: (string) | null;
    /**
     * Ссылка на оплату
     */
    paymentUrl: (string) | null;
};

export namespace PaymentDetailDto {
    /**
     * Метод оплаты
     */
    export enum paymentMethod {
        CARD = 'card',
        SBP = 'sbp',
        ACQUIRING = 'acquiring'
    }
    /**
     * Статус платежа
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        PARTIALLY_REFUNDED = 'partially_refunded',
        REFUNDED = 'refunded'
    }
}

export type PaymentEventItemDto = {
    /**
     * UUID события
     */
    uuid: string;
    /**
     * Статус T-Bank
     */
    tbankStatus: string;
    /**
     * Наш статус
     */
    ourStatus: string;
    /**
     * Человекочитаемый статус на русском
     */
    statusDisplay: string;
    /**
     * Сумма в копейках
     */
    amount: (number) | null;
    /**
     * Код ошибки
     */
    errorCode: (string) | null;
    /**
     * Успех
     */
    success: (boolean) | null;
    /**
     * Источник события
     */
    eventSource: 'webhook' | 'api_init' | 'api_confirm' | 'api_cancel' | 'manual';
    /**
     * Дата создания
     */
    createdAt: string;
};

export namespace PaymentEventItemDto {
    /**
     * Источник события
     */
    export enum eventSource {
        WEBHOOK = 'webhook',
        API_INIT = 'api_init',
        API_CONFIRM = 'api_confirm',
        API_CANCEL = 'api_cancel',
        MANUAL = 'manual'
    }
}

export type PaymentEventsResponseDto = {
    /**
     * Список событий платежа (хронологический порядок)
     */
    data: Array<PaymentEventItemDto>;
};

export type PaymentResponseDto = {
    /**
     * UUID платежа
     */
    uuid: string;
    /**
     * UUID бронирования
     */
    booking_uuid: string;
    /**
     * Сумма платежа
     */
    amount: number;
    /**
     * Валюта
     */
    currency: string;
    /**
     * Метод оплаты
     */
    payment_method: 'card' | 'sbp' | 'acquiring';
    /**
     * Статус платежа
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'partially_refunded' | 'refunded';
    /**
     * ID операции в Точка Банке
     */
    tochka_operation_id: {
        [key: string]: unknown;
    } | null;
    /**
     * URL для оплаты
     */
    payment_url: {
        [key: string]: unknown;
    } | null;
    /**
     * QR код для СБП (Base64 или payload строка)
     */
    qr_code: {
        [key: string]: unknown;
    } | null;
    /**
     * Сообщение об ошибке
     */
    error_message: {
        [key: string]: unknown;
    } | null;
    /**
     * Дата и время оплаты
     */
    paid_at: {
        [key: string]: unknown;
    } | null;
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export namespace PaymentResponseDto {
    /**
     * Метод оплаты
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp',
        ACQUIRING = 'acquiring'
    }
    /**
     * Статус платежа
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        PARTIALLY_REFUNDED = 'partially_refunded',
        REFUNDED = 'refunded'
    }
}

export type PaymentSchemeDto = {
    uuid: string;
    service_center_uuid: string;
    parent_template_uuid: (string) | null;
    parent_template_name: (string) | null;
    parent_version: (number) | null;
    template_version: (number) | null;
    /**
     * Шаблон меняли после последнего применения к этому сотруднику. После Save шаблона почти всегда false: пролив выставляет parent_version. Тултип не отдаём.
     */
    is_stale: boolean;
    /**
     * У сотрудника есть ручные ставки, которые пролив шаблона не затирает
     */
    has_overrides: boolean;
    fix_per_shift: (string) | null;
    fix_per_shift_overridden: boolean;
    hourly_rate: (string) | null;
    hourly_rate_overridden: boolean;
    version: number;
    services: Array<PaymentSchemeServiceRowDto>;
};

export type PaymentSchemeServiceInputDto = {
    service_uuid: string;
    rate_type: 'fixed' | 'percent';
    /**
     * ₽ для fixed, проценты для percent (0–100)
     */
    value: number;
};

export namespace PaymentSchemeServiceInputDto {
    export enum rate_type {
        FIXED = 'fixed',
        PERCENT = 'percent'
    }
}

export type PaymentSchemeServiceRowDto = {
    service_uuid: string;
    /**
     * Название услуги из каталога мойки
     */
    name: string;
    /**
     * null — ставка по услуге ещё не задана, на форме пустая ячейка
     */
    rate_type: ('fixed' | 'percent') | null;
    value: (string) | null;
    /**
     * Строку правили руками, пролив шаблона её не тронет
     */
    is_overridden: boolean;
};

export namespace PaymentSchemeServiceRowDto {
    /**
     * null — ставка по услуге ещё не задана, на форме пустая ячейка
     */
    export enum rate_type {
        FIXED = 'fixed',
        PERCENT = 'percent'
    }
}

export type PaymentSchemeTemplateDto = {
    uuid: string;
    service_center_uuid: string;
    name: string;
    fix_per_shift: (string) | null;
    hourly_rate: (string) | null;
    version: number;
    is_archived: boolean;
    /**
     * Сколько сотрудников на шаблоне
     */
    employees_count: number;
    services: Array<PaymentSchemeServiceRowDto>;
};

export type PaymentSchemeTemplateListItemDto = {
    uuid: string;
    name: string;
    fix_per_shift: (string) | null;
    hourly_rate: (string) | null;
    version: number;
    is_archived: boolean;
    employees_count: number;
};

export type PaymentSchemeTemplateListResponseDto = {
    data: Array<PaymentSchemeTemplateListItemDto>;
    total: number;
    limit: number;
    offset: number;
};

export type PaymentSchemeTemplateWithPropagationDto = {
    uuid: string;
    service_center_uuid: string;
    name: string;
    fix_per_shift: (string) | null;
    hourly_rate: (string) | null;
    version: number;
    is_archived: boolean;
    /**
     * Сколько сотрудников на шаблоне
     */
    employees_count: number;
    services: Array<PaymentSchemeServiceRowDto>;
    /**
     * Сохранение шаблона обновляет сотрудников на нём — что именно произошло
     */
    propagation?: (PropagationResultDto);
};

export type PaymentStatusResponseDto = {
    /**
     * Статус платежа
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'partially_refunded' | 'refunded';
    /**
     * Сумма платежа
     */
    amount: number;
    /**
     * Метод оплаты
     */
    payment_method: 'card' | 'sbp' | 'acquiring';
    /**
     * Дата и время оплаты
     */
    paid_at: {
        [key: string]: unknown;
    } | null;
};

export namespace PaymentStatusResponseDto {
    /**
     * Статус платежа
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        PARTIALLY_REFUNDED = 'partially_refunded',
        REFUNDED = 'refunded'
    }
    /**
     * Метод оплаты
     */
    export enum payment_method {
        CARD = 'card',
        SBP = 'sbp',
        ACQUIRING = 'acquiring'
    }
}

export type PayoutConfirmDto = {
    /**
     * UUID сессии, полученный на шаге /request
     */
    sessionId: string;
    /**
     * SMS-код подтверждения (4 цифры)
     */
    code: string;
};

export type PayoutConfirmResponseDto = {
    /**
     * Результаты выплат по каждому контрагенту
     */
    payouts: Array<PayoutResultItemDto>;
};

export type PayoutDetailBookingDto = {
    uuid: string;
    startTime: string;
    endTime?: (string) | null;
    status: string;
    paymentStatus: string;
    totalCost: number;
    serviceName: string;
    clientName: string;
    clientPhone: string;
    carMake?: (string) | null;
    carModel?: (string) | null;
};

export type PayoutDetailDto = {
    uuid: string;
    /**
     * Сумма выплаты (копейки)
     */
    amount: number;
    status: 'pending' | 'processing' | 'success' | 'failed';
    tbankPaymentId?: (string) | null;
    /**
     * FinalPayout — была ли это закрывающая сделку выплата
     */
    finalPayout: boolean;
    createdAt: string;
    processedAt?: (string) | null;
};

export namespace PayoutDetailDto {
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed'
    }
}

export type PayoutDetailPaymentDto = {
    uuid: string;
    /**
     * Сумма платежа (руб.)
     */
    amount: number;
    status: string;
    tbankPaymentId?: (string) | null;
    tbankDealId?: (string) | null;
    tbankOrderId?: (string) | null;
    paidAt?: (string) | null;
    createdAt: string;
};

export type PayoutDetailServiceCenterDto = {
    uuid: string;
    name: string;
    contractorType?: ('legal_entity' | 'individual') | null;
    sbpMemberId?: (string) | null;
    paymentRecipientPhone?: (string) | null;
};

export namespace PayoutDetailServiceCenterDto {
    export enum contractorType {
        LEGAL_ENTITY = 'legal_entity',
        INDIVIDUAL = 'individual'
    }
}

export type PayoutItemDto = {
    uuid: string;
    /**
     * Дата выплаты
     */
    date: string;
    /**
     * Сумма в копейках
     */
    amount: number;
    /**
     * Статус выплаты
     */
    status: 'pending' | 'processing' | 'success' | 'failed';
};

export namespace PayoutItemDto {
    /**
     * Статус выплаты
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed'
    }
}

export type PayoutRequestDto = {
    /**
     * Список контрагентов и сумм для выплаты
     */
    targets: Array<PayoutTargetDto>;
};

export type PayoutRequestResponseDto = {
    /**
     * UUID сессии выплаты
     */
    sessionId: string;
    /**
     * Количество контрагентов в сессии
     */
    targetCount: number;
    /**
     * Верифицированная суммарная сумма выплаты (руб.) — пересчитана на бэке
     */
    totalAmount: number;
    /**
     * Время истечения сессии и SMS-кода (ISO 8601)
     */
    expiresAt: string;
};

export type PayoutResultItemDto = {
    /**
     * UUID сервисного центра
     */
    serviceCenterId: string;
    /**
     * Итоговая сумма выплаты (руб.)
     */
    amount: number;
    /**
     * Статус транзакции в T-Bank
     */
    status: 'processing' | 'completed' | 'failed';
};

export namespace PayoutResultItemDto {
    /**
     * Статус транзакции в T-Bank
     */
    export enum status {
        PROCESSING = 'processing',
        COMPLETED = 'completed',
        FAILED = 'failed'
    }
}

export type PayoutsListResponseDto = {
    /**
     * Текущий баланс к выплате (руб.)
     */
    pendingPayout: number;
    /**
     * Дата последней успешной выплаты
     */
    lastPayoutDate?: {
        [key: string]: unknown;
    } | null;
    data: Array<PayoutItemDto>;
    meta: PaginationMetaDto;
};

export type PayoutTargetDto = {
    /**
     * UUID сервисного центра
     */
    serviceCenterId: string;
    /**
     * Сумма выплаты в рублях (значение с фронта, будет верифицировано на бэке)
     */
    amount: number;
};

export type PropagationEmployeeDto = {
    employee_uuid: string;
    full_name: string;
};

export type PropagationResultDto = {
    /**
     * true — превью, в базу ничего не записано
     */
    dry_run: boolean;
    updated_count: number;
    overrides_count: number;
    linked_count: number;
    /**
     * true — списки сотрудников обрезаны до первых 50
     */
    has_more: boolean;
    /**
     * Кому ставки реально поменяли (первые 50)
     */
    updated_employees: Array<PropagationEmployeeDto>;
    /**
     * У кого остались ручные правки. Сотрудник может быть и здесь, и в updated_employees.
     */
    employees_with_overrides: Array<PropagationEmployeeDto>;
};

export type PublicSystemSettingsResponseDto = {
    /**
     * Табы приложения в порядке отображения
     */
    tabs: Array<'help' | 'gas_stations' | 'car_wash' | 'tire_service'>;
    /**
     * Базовый URL API для мобильного приложения
     */
    api_base_url: string;
    /**
     * URL админ-панели
     */
    admin_panel_url: string;
    /**
     * Дата последнего обновления
     */
    updated_at: string;
};

export type PushCampaignWriteDto = {
    name: string;
    title: string;
    body: string;
    subtitle?: {
        [key: string]: unknown;
    };
    link_kind?: 'none' | 'service_center' | 'closest' | 'bookings';
    link_service_center_uuid?: {
        [key: string]: unknown;
    };
    target_business_type?: ('car_wash' | 'tire_service') | null;
    audience_mode?: 'all_matching' | 'client_uuids';
    audience_query?: {
        [key: string]: unknown;
    };
    client_uuids?: Array<string>;
    attribution_window_hours?: number;
};

export namespace PushCampaignWriteDto {
    export enum link_kind {
        NONE = 'none',
        SERVICE_CENTER = 'service_center',
        CLOSEST = 'closest',
        BOOKINGS = 'bookings'
    }
    export enum target_business_type {
        CAR_WASH = 'car_wash',
        TIRE_SERVICE = 'tire_service'
    }
    export enum audience_mode {
        ALL_MATCHING = 'all_matching',
        CLIENT_UUIDS = 'client_uuids'
    }
}

export type ReceiptDetailDto = {
    /**
     * UUID чека
     */
    uuid: string;
    /**
     * Тип чека
     */
    type: 'Income' | 'IncomeReturn';
    /**
     * Статус чека
     */
    status: 'Queued' | 'Processed' | 'Error' | 'NotFound';
    /**
     * URL чека
     */
    receiptUrl: (string) | null;
    /**
     * Фискальный признак
     */
    fiscalSign: (string) | null;
    /**
     * Фискальный номер
     */
    fiscalNumber: (string) | null;
    /**
     * ID в CloudKassir
     */
    cloudkassirId: (string) | null;
    /**
     * ИНН
     */
    inn: string;
    /**
     * Сумма чека
     */
    amount: number;
    /**
     * Дата создания
     */
    createdAt: string;
};

export namespace ReceiptDetailDto {
    /**
     * Тип чека
     */
    export enum type {
        INCOME = 'Income',
        INCOME_RETURN = 'IncomeReturn'
    }
    /**
     * Статус чека
     */
    export enum status {
        QUEUED = 'Queued',
        PROCESSED = 'Processed',
        ERROR = 'Error',
        NOT_FOUND = 'NotFound'
    }
}

export type ReducedServiceCenterResponseDto = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
    /**
     * Название сервисного центра
     */
    name: string;
    /**
     * Адрес сервисного центра
     */
    address: string;
    /**
     * Координаты местоположения сервисного центра
     */
    location: (ServiceCenterLocationDto);
    /**
     * Внешний рейтинг сервисного центра
     */
    external_rating: {
        [key: string]: unknown;
    } | null;
    /**
     * Расстояние до сервисного центра в метрах
     */
    distance_meters: number;
    /**
     * URL логотипа сервисного центра
     */
    logo_url: {
        [key: string]: unknown;
    } | null;
    /**
     * Открыт ли сервисный центр в данный момент
     */
    is_open_now?: boolean;
    /**
     * Находится ли сервисный центр в избранном у пользователя
     */
    isFavorite?: boolean;
    /**
     * Дата и время ближайшего доступного слота для записи
     */
    closestSlot?: string;
    /**
     * Минимальная цена за услугу в сервисном центре исходя из текущей фильтрации
     */
    priceStart?: number;
    /**
     * Тип бизнеса сервисного центра
     */
    business_type: 'tire_service' | 'car_wash';
};

export namespace ReducedServiceCenterResponseDto {
    /**
     * Тип бизнеса сервисного центра
     */
    export enum business_type {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
}

export type RefreshDto = {
    /**
     * Refresh токен
     */
    refreshToken: string;
    /**
     * Уникальный идентификатор устройства
     */
    device_id?: string;
};

export type RefreshResponseDto = {
    /**
     * Статус успешности операции
     */
    success: boolean;
    /**
     * Сообщение о результате операции
     */
    message: string;
    /**
     * Новый JWT access токен
     */
    accessToken: string;
    /**
     * Новый JWT refresh токен
     */
    refreshToken: string;
};

export type RegisterDto = {
    /**
     * Уникальный идентификатор устройства
     */
    device_id?: string;
};

export type RegisterTokenDto = {
    /**
     * Expo push token устройства (ExponentPushToken[...])
     */
    token: string;
    /**
     * Уникальный ID устройства
     */
    deviceId: string;
    /**
     * Тип устройства
     */
    deviceType?: string;
    /**
     * Название устройства
     */
    deviceName?: string;
};

export type RequestAccountDeletionByPhoneDto = {
    phone: string;
};

export type RevenueChartPointDto = {
    /**
     * Номер месяца (1-12)
     */
    month: number;
    /**
     * Короткое название месяца
     */
    label: string;
    /**
     * Накопительный итог с начала года (руб.)
     */
    cumulative: number;
};

export type RevenueStatsDto = {
    /**
     * Общий оборот за год (руб.)
     */
    total: number;
    /**
     * Изменение относительно предыдущего года (%)
     */
    changePercent: number;
    /**
     * Помесячный накопительный график
     */
    chart: Array<RevenueChartPointDto>;
};

export type Role = {
    [key: string]: unknown;
};

export type RoleResponseDto = {
    /**
     * UUID роли
     */
    uuid: string;
    /**
     * Название роли
     */
    name: string;
    /**
     * Уникальный ключ роли
     */
    key: string;
    /**
     * Тип роли
     */
    type: 'ADMIN' | 'SUPERADMIN' | 'USER' | 'CLIENT';
    /**
     * Описание роли
     */
    description: string;
    /**
     * Список разрешений роли
     */
    permissions: Array<string>;
};

export namespace RoleResponseDto {
    /**
     * Тип роли
     */
    export enum type {
        ADMIN = 'ADMIN',
        SUPERADMIN = 'SUPERADMIN',
        USER = 'USER',
        CLIENT = 'CLIENT'
    }
}

export type ScheduleConflictErrorDto = {
    /**
     * Код ошибки
     */
    error: string;
    /**
     * Сообщение об ошибке
     */
    message: string;
    /**
     * Список конфликтующих бронирований
     */
    conflicting_bookings: Array<ConflictingBookingDto>;
    /**
     * Количество конфликтующих бронирований
     */
    count: number;
};

export type SchedulePushCampaignDto = {
    scheduled_at: string;
};

export type ScStatsResponseDto = {
    /**
     * Блок «Оборот»
     */
    revenue: (RevenueStatsDto);
    /**
     * Блок «Бронирования»
     */
    bookings: (BookingsStatsDto);
    /**
     * Блок «Средний чек»
     */
    averageCheck: (AverageCheckStatsDto);
    /**
     * Блок «Комиссия»
     */
    commission: (CommissionStatsDto);
};

export type SendCodeDto = {
    phone: string;
};

export type Service = {
    [key: string]: unknown;
};

export type ServiceCenterContactsDto = {
    /**
     * Номер телефона
     */
    phone?: string;
    /**
     * Email адрес
     */
    email?: string;
    /**
     * Веб-сайт
     */
    website?: string;
};

export type ServiceCenterLocationDto = {
    /**
     * Широта местоположения
     */
    lat: number;
    /**
     * Долгота местоположения
     */
    lon: number;
};

export type ServiceCenterPostResponseDto = {
    /**
     * UUID поста
     */
    uuid: string;
    /**
     * Порядковый номер поста (вычисляется на основе даты создания)
     */
    orderNumber: number;
    /**
     * Доступен ли пост для онлайн записи
     */
    isAvailableForOnlineBooking: boolean;
    /**
     * Дата создания
     */
    created_at: string;
};

export type ServiceCenterPostsListResponseDto = {
    /**
     * Список постов
     */
    data: Array<ServiceCenterPostResponseDto>;
    /**
     * Общее количество постов
     */
    total: number;
};

export type ServiceCenterSummaryChartsDto = {
    /**
     * Данные графика «Всего бронирований» по неделям
     */
    totalBookings: Array<number>;
    /**
     * Данные графика «Бронирований через приложение» по неделям
     */
    appBookings: Array<number>;
    /**
     * Данные графика «Общая выручка» по неделям (руб.)
     */
    totalRevenue: Array<number>;
    /**
     * Данные графика «Комиссия» по неделям (руб.)
     */
    totalCommission: Array<number>;
};

export type ServiceCenterWorkingHoursDto = {
    /**
     * Понедельник
     */
    mon?: string;
    /**
     * Вторник
     */
    tue?: string;
    /**
     * Среда
     */
    wed?: string;
    /**
     * Четверг
     */
    thu?: string;
    /**
     * Пятница
     */
    fri?: string;
    /**
     * Суббота
     */
    sat?: string;
    /**
     * Воскресенье
     */
    sun?: string;
};

export type ServiceDto = {
    /**
     * Уникальный идентификатор услуги
     */
    uuid: string;
    /**
     * Название услуги
     */
    name: string;
    /**
     * Цена услуги (базовая, для обратной совместимости)
     */
    price: number;
    /**
     * Длительность услуги в минутах
     */
    duration_minutes: number;
    /**
     * Категория услуги
     */
    category: string;
    /**
     * Тип бизнеса
     */
    business_type: 'tire_service' | 'car_wash';
    /**
     * Тип услуги
     */
    service_type: 'main' | 'additional';
    /**
     * Описание услуги
     */
    description: (string) | null;
    /**
     * Дополнительные заметки
     */
    notes: (string) | null;
    /**
     * Массив цен для разных параметров (класс авто или размер колеса)
     */
    servicePrices?: Array<{
        uuid?: string;
        parameter_type?: 'simple_car_class' | 'wheel_size';
        parameter_value?: string;
        price?: number;
        is_active?: boolean;
    }>;
};

export namespace ServiceDto {
    /**
     * Тип бизнеса
     */
    export enum business_type {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
    /**
     * Тип услуги
     */
    export enum service_type {
        MAIN = 'main',
        ADDITIONAL = 'additional'
    }
}

export type ServiceShareDto = {
    /**
     * Название услуги
     */
    serviceName: string;
    /**
     * Доля в общем обороте (%)
     */
    percent: number;
};

export type SetPhoneDto = {
    /**
     * Номер телефона
     */
    phone: string;
    /**
     * Код подтверждения из SMS
     */
    code: string;
    /**
     * Уникальный идентификатор устройства
     */
    device_id?: string;
};

export type StatsChangeDto = {
    /**
     * Текущее значение метрики
     */
    current: number;
    /**
     * Процентное изменение по сравнению с предыдущим периодом (может быть отрицательным)
     */
    change_percent: number;
};

export type SubmitGasStationReportDto = {
    /**
     * Цена газа в каталоге. null — цена неизвестна. Доступность — через fuel_available или null в price_*
     */
    price_gas?: (number) | null;
    /**
     * Цена ДТ в каталоге. null — цена неизвестна
     */
    price_dt?: (number) | null;
    /**
     * Цена АИ-92 в каталоге. null — цена неизвестна
     */
    price_ai_92?: (number) | null;
    /**
     * Цена АИ-95 в каталоге. null — цена неизвестна
     */
    price_ai_95?: (number) | null;
    /**
     * Цена АИ-95+ в каталоге. null — цена неизвестна
     */
    price_ai_95_plus?: (number) | null;
    /**
     * Цена АИ-98 в каталоге. null — цена неизвестна
     */
    price_ai_98?: (number) | null;
    /**
     * Цена АИ-100 в каталоге. null — цена неизвестна
     */
    price_ai_100?: (number) | null;
    /**
     * Статус заправки
     */
    status?: 'yes' | 'queue' | 'low' | 'no';
    /**
     * Дополнительная информация
     */
    detail?: string;
    /**
     * Размер очереди в минутах. null — неизвестно
     */
    queue_minutes?: (number) | null;
    /**
     * Доступность видов топлива
     */
    fuel_available?: (FuelAvailabilityDto);
};

export namespace SubmitGasStationReportDto {
    /**
     * Статус заправки
     */
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type SuggestAddressDto = {
    /**
     * Поисковый запрос (адрес или его часть)
     */
    query: string;
};

export type SuggestBankDto = {
    /**
     * Поисковый запрос
     */
    query: string;
};

export type SuggestPartyDto = {
    /**
     * Поисковый запрос
     */
    query: string;
};

export type SuperadminClientDetailDto = {
    uuid: string;
    firstName: string;
    lastName: string;
    phone: string;
    email?: (string) | null;
    status: 'active' | 'blocked';
    /**
     * Дата регистрации (ISO)
     */
    registeredAt: string;
    /**
     * Дата последнего визита (ISO)
     */
    lastVisitAt?: (string) | null;
    /**
     * Количество автомобилей
     */
    carsCount: number;
    /**
     * Общее количество бронирований за всё время
     */
    totalBookingsAllTime: number;
    /**
     * Автомобили клиента
     */
    cars: Array<ClientDetailCarDto>;
};

export namespace SuperadminClientDetailDto {
    export enum status {
        ACTIVE = 'active',
        BLOCKED = 'blocked'
    }
}

export type SuperadminClientListItemDto = {
    uuid: string;
    name?: (string) | null;
    phone?: (string) | null;
    email?: (string) | null;
    /**
     * Количество бронирований за выбранный период
     */
    bookingsCount: number;
    /**
     * Сумма расходов за выбранный период (руб.)
     */
    totalSpent: number;
    /**
     * Сервисные центры, в которых клиент был активен
     */
    serviceCenters: Array<ClientServiceCenterRefDto>;
    created_at: string;
    updated_at: string;
};

export type SuperadminClientListResponseDto = {
    data: Array<SuperadminClientListItemDto>;
    meta: PaginationMetaDto;
};

export type SuperadminClientSummaryDto = {
    /**
     * Новые зарегистрированные клиенты за период
     */
    totalUsers: number;
    /**
     * Изменение количества новых клиентов (%)
     */
    totalUsersChange: number;
    /**
     * Суммарное количество бронирований за период
     */
    totalBookings: number;
    /**
     * Изменение количества бронирований (%)
     */
    totalBookingsChange: number;
    /**
     * Доля бронирований через мобильное приложение (%)
     */
    appBookingsPct: number;
    /**
     * Изменение доли бронирований через приложение (п.п.)
     */
    appBookingsPctChange: number;
    /**
     * Доля клиентов, совершивших ≥1 бронирование за период (%)
     */
    activeUsersPct: number;
    /**
     * Изменение доли активных клиентов (п.п.)
     */
    activeUsersPctChange: number;
    /**
     * Данные для графиков
     */
    charts: (ClientSummaryChartsDto);
};

export type SuperadminHelpOrderDetailDto = {
    uuid: string;
    status: 'awaiting_confirmation' | 'en_route' | 'on_site' | 'in_progress' | 'completed' | 'cancelled';
    kind: 'tow' | 'fuel' | 'jump_start';
    client_name: string;
    client_phone: string;
    vehicle_make_model: string;
    vehicle_reg_number: string;
    vehicle_vin?: (string) | null;
    vehicle_year?: (string) | null;
    pickup: HelpPointDto;
    dropoff?: ((HelpPointDto) | null);
    blocked_wheels: number;
    hard_to_access: boolean;
    comment?: (string) | null;
    files: Array<string>;
    items: Array<HelpOrderItemDto>;
    prepaid_amount: number;
    prepaid_status: 'pending' | 'success' | 'refunded';
    extra_amount: number;
    extra_payment_status: 'pending' | 'success' | 'refunded';
    total_amount: number;
    executor?: ((HelpExecutorSnapshotDto) | null);
    events: Array<HelpOrderEventDto>;
    created_at: string;
    updated_at: string;
    client_uuid: string;
    car_uuid?: (string) | null;
};

export namespace SuperadminHelpOrderDetailDto {
    export enum status {
        AWAITING_CONFIRMATION = 'awaiting_confirmation',
        EN_ROUTE = 'en_route',
        ON_SITE = 'on_site',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
    export enum prepaid_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
    export enum extra_payment_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
}

export type SuperadminHelpOrderListItemDto = {
    uuid: string;
    created_at: string;
    client_name: string;
    client_phone: string;
    vehicle_reg_number: string;
    kind: 'tow' | 'fuel' | 'jump_start';
    service_title: string;
    status: 'awaiting_confirmation' | 'en_route' | 'on_site' | 'in_progress' | 'completed' | 'cancelled';
    total_amount: number;
    prepaid_status: 'pending' | 'success' | 'refunded';
};

export namespace SuperadminHelpOrderListItemDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start'
    }
    export enum status {
        AWAITING_CONFIRMATION = 'awaiting_confirmation',
        EN_ROUTE = 'en_route',
        ON_SITE = 'on_site',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
    export enum prepaid_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
}

export type SuperadminHelpOrdersListResponseDto = {
    data: Array<SuperadminHelpOrderListItemDto>;
    meta: PaginationMetaDto;
    metrics: HelpOrdersMetricsDto;
};

export type SuperadminPaymentDetailResponseDto = {
    /**
     * Данные платежа
     */
    payment: (PaymentDetailDto);
    /**
     * Статус в T-Bank (null если недоступен)
     */
    tbankState: ((TBankStateDto) | null);
    /**
     * Чек прихода (null если нет)
     */
    receipt: ((ReceiptDetailDto) | null);
    /**
     * Чек возврата (null если нет)
     */
    refundReceipt: ((ReceiptDetailDto) | null);
    /**
     * Связанное бронирование
     */
    booking: (BookingDetailDto);
};

export type SuperadminPayoutDetailResponseDto = {
    payout: PayoutDetailDto;
    payment: PayoutDetailPaymentDto;
    booking: PayoutDetailBookingDto;
    serviceCenter: PayoutDetailServiceCenterDto;
};

export type SuperadminPushableClientItemDto = {
    uuid: string;
    name?: (string) | null;
    phone?: (string) | null;
    email?: (string) | null;
    created_at: string;
    /**
     * Количество активных устройств с push-токеном
     */
    activeDevicesCount: number;
};

export type SuperadminPushableClientsListResponseDto = {
    data: Array<SuperadminPushableClientItemDto>;
    meta: PaginationMetaDto;
};

export type SuperadminSendPushNotificationsDto = {
    /**
     * Заголовок push-уведомления
     */
    title: string;
    /**
     * Текст push-уведомления
     */
    body: string;
    /**
     * Подзаголовок push-уведомления
     */
    subtitle?: string;
    /**
     * UUID клиентов для отправки (до 500). Взаимоисключающе с allMatching
     */
    clientUuids?: Array<string>;
    /**
     * Отправить всем клиентам, подходящим под фильтры списка pushable-clients
     */
    allMatching?: boolean;
    /**
     * Поисковый запрос для allMatching (имя, телефон, email)
     */
    q?: string;
};

export type SuperadminSendPushNotificationsResponseDto = {
    /**
     * Сколько клиентов было запрошено к отправке
     */
    requested: number;
    /**
     * Сколько клиентов прошли проверку eligibility
     */
    eligible: number;
    /**
     * Сколько устройств получили push
     */
    sentDevices: number;
    /**
     * Сколько клиентов получили push хотя бы на одно устройство
     */
    usersNotified: number;
    /**
     * Сколько клиентов было пропущено (не eligible)
     */
    skipped: number;
};

export type SuperadminServiceCenterDetailDto = {
    uuid: string;
    name: string;
    projectUuid: string;
    address: string;
    location: {
        [key: string]: unknown;
    };
    description?: {
        [key: string]: unknown;
    } | null;
    logo_url?: {
        [key: string]: unknown;
    } | null;
    photo_gallery_urls: Array<string>;
    working_hours: {
        [key: string]: unknown;
    };
    contacts: {
        [key: string]: unknown;
    };
    external_rating?: {
        [key: string]: unknown;
    } | null;
    payment_recipient_phone?: (string) | null;
    inn?: (string) | null;
    legal_name?: (string) | null;
    ogrn?: (string) | null;
    kpp?: (string) | null;
    legal_address?: (string) | null;
    director_name?: (string) | null;
    contract_number?: (string) | null;
    contract_date?: (string) | null;
    bank_name?: (string) | null;
    bik?: (string) | null;
    correspondent_account?: (string) | null;
    settlement_account?: (string) | null;
    isPublished: boolean;
    bookingsCount: number;
    appBookingsCount: number;
    rating: number;
    revenue: number;
    commission: number;
    pendingPayout: number;
    commissionRate: number;
    created_at: string;
    updated_at: string;
    /**
     * Количество постов (рабочих мест)
     */
    postsCount: number;
    /**
     * Список типов бизнеса из услуг СЦ
     */
    businessTypes: Array<string>;
};

export type SuperadminServiceCenterItemDto = {
    uuid: string;
    name: string;
    address: string;
    location: {
        [key: string]: unknown;
    };
    logo_url?: {
        [key: string]: unknown;
    } | null;
    isPublished: boolean;
    payment_recipient_phone?: {
        [key: string]: unknown;
    } | null;
    inn?: {
        [key: string]: unknown;
    } | null;
    legal_name?: {
        [key: string]: unknown;
    } | null;
    /**
     * Количество бронирований за выбранный месяц
     */
    bookingsCount: number;
    /**
     * Выручка за выбранный месяц (руб.)
     */
    revenue: number;
    /**
     * Начисленная комиссия за выбранный месяц (руб.)
     */
    commission: number;
    /**
     * Текущий баланс к выплате (накопленный, не за месяц)
     */
    pendingPayout: number;
    /**
     * Ставка комиссии (%)
     */
    commissionRate: number;
    /**
     * Средний рейтинг сервисного центра
     */
    rating: number;
    created_at: string;
    updated_at: string;
};

export type SuperadminServiceCenterListResponseDto = {
    data: Array<SuperadminServiceCenterItemDto>;
    meta: PaginationMetaDto;
};

export type SuperadminServiceCenterSummaryDto = {
    /**
     * Суммарное количество бронирований за период
     */
    totalBookings: number;
    /**
     * Изменение количества бронирований относительно предыдущего периода (%)
     */
    totalBookingsChange: number;
    /**
     * Количество бронирований через приложение за период
     */
    appBookings: number;
    /**
     * Изменение бронирований через приложение относительно предыдущего периода (%)
     */
    appBookingsChange: number;
    /**
     * Суммарная выручка всех СЦ за период (руб.)
     */
    totalRevenue: number;
    /**
     * Изменение выручки относительно предыдущего периода (%)
     */
    totalRevenueChange: number;
    /**
     * Суммарная начисленная комиссия за период (руб.)
     */
    totalCommission: number;
    /**
     * Изменение комиссии относительно предыдущего периода (%)
     */
    totalCommissionChange: number;
    /**
     * Данные для графиков (по ~10 точкам в разрезе по неделям)
     */
    charts: (ServiceCenterSummaryChartsDto);
};

export type SystemSettingEntryDto = {
    /**
     * Ключ настройки
     */
    key: string;
    /**
     * Значение настройки (структура зависит от key)
     */
    value: {
        [key: string]: unknown;
    };
    /**
     * Дата последнего обновления
     */
    updated_at: string;
};

export type SystemSettingsResponseDto = {
    /**
     * Список глобальных настроек (key-value)
     */
    settings: Array<SystemSettingEntryDto>;
};

export type TBankStateDto = {
    /**
     * Статус в T-Bank
     */
    status: string;
    /**
     * Сумма в копейках
     */
    amount: number;
    /**
     * ID заказа
     */
    orderId: string;
    /**
     * Синхронизирован ли статус с нашей БД
     */
    synced: boolean;
    /**
     * Код ошибки от T-Bank
     */
    errorCode: (string) | null;
    /**
     * Сообщение об ошибке от T-Bank
     */
    message: (string) | null;
    /**
     * Детали ошибки от T-Bank
     */
    details: (string) | null;
};

export type TBankWebhookDto = {
    /**
     * Ключ терминала T-Bank
     */
    TerminalKey: string;
    /**
     * UUID бронирования (OrderId)
     */
    OrderId: string;
    /**
     * Флаг успешности операции
     */
    Success: boolean;
    /**
     * Статус платежа
     */
    Status: 'NEW' | 'FORM_SHOWED' | 'AUTHORIZING' | '3DS_CHECKING' | '3DS_CHECKED' | 'PAY_CHECKING' | 'AUTHORIZED' | 'CONFIRMING' | 'CONFIRMED' | 'REVERSING' | 'REVERSED' | 'PARTIAL_REVERSED' | 'REFUNDING' | 'REFUNDED' | 'PARTIAL_REFUNDED' | 'REJECTED' | 'CANCELED' | 'DEADLINE_EXPIRED' | 'AUTH_FAIL';
    /**
     * ID платежа в T-Bank
     */
    PaymentId: string;
    /**
     * Сумма платежа в копейках
     */
    Amount: number;
    /**
     * Код ошибки (если есть)
     */
    ErrorCode?: string;
    /**
     * ID сделки для MultiSplit
     */
    SpAccumulationId?: string;
    /**
     * Подпись webhook (Token)
     */
    Token: string;
};

export namespace TBankWebhookDto {
    /**
     * Статус платежа
     */
    export enum Status {
        NEW = 'NEW',
        FORM_SHOWED = 'FORM_SHOWED',
        AUTHORIZING = 'AUTHORIZING',
        _3DS_CHECKING = '3DS_CHECKING',
        _3DS_CHECKED = '3DS_CHECKED',
        PAY_CHECKING = 'PAY_CHECKING',
        AUTHORIZED = 'AUTHORIZED',
        CONFIRMING = 'CONFIRMING',
        CONFIRMED = 'CONFIRMED',
        REVERSING = 'REVERSING',
        REVERSED = 'REVERSED',
        PARTIAL_REVERSED = 'PARTIAL_REVERSED',
        REFUNDING = 'REFUNDING',
        REFUNDED = 'REFUNDED',
        PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED',
        DEADLINE_EXPIRED = 'DEADLINE_EXPIRED',
        AUTH_FAIL = 'AUTH_FAIL'
    }
}

export type TestPushCampaignDto = {
    client_uuids: Array<string>;
};

export type ToggleGasStationFavoriteResponseDto = {
    isFavorite: boolean;
};

export type TopicResponseDto = {
    /**
     * UUID темы
     */
    uuid: string;
    /**
     * Название темы
     */
    name: string;
    /**
     * Порядок сортировки
     */
    sort_order: number;
    /**
     * Активна ли тема
     */
    is_active: boolean;
    /**
     * Дата создания
     */
    created_at: string;
    /**
     * Дата обновления
     */
    updated_at: string;
};

export type TopServiceDto = {
    /**
     * UUID услуги
     */
    service_uuid: string;
    /**
     * Название услуги
     */
    service_name: string;
    /**
     * Количество записей на эту услугу
     */
    bookings_count: number;
    /**
     * Общая выручка от этой услуги
     */
    revenue: number;
};

export type TransactionItemDto = {
    uuid: string;
    /**
     * Дата операции
     */
    date: string;
    /**
     * Тип операции
     */
    type: 'payment' | 'refund' | 'payout';
    /**
     * Описание операции
     */
    description: string;
    /**
     * Метод оплаты (только для платежей)
     */
    paymentMethod?: ('card' | 'sbp' | 'cash') | null;
    /**
     * Сумма операции в копейках
     */
    amount: number;
    /**
     * Статус операции
     */
    status: 'pending' | 'processing' | 'success' | 'failed' | 'refunded' | 'partially_refunded';
    /**
     * Отображаемый статус на русском
     */
    statusDisplay: string;
    /**
     * UUID связанного бронирования (для платежей/возвратов)
     */
    bookingUuid?: (string) | null;
    /**
     * ID платежа в T-Bank
     */
    tbankPaymentId?: (string) | null;
    /**
     * ID заказа в T-Bank
     */
    tbankOrderId?: (string) | null;
    /**
     * Сообщение об ошибке (при failed)
     */
    errorMessage?: (string) | null;
};

export namespace TransactionItemDto {
    /**
     * Тип операции
     */
    export enum type {
        PAYMENT = 'payment',
        REFUND = 'refund',
        PAYOUT = 'payout'
    }
    /**
     * Метод оплаты (только для платежей)
     */
    export enum paymentMethod {
        CARD = 'card',
        SBP = 'sbp',
        CASH = 'cash'
    }
    /**
     * Статус операции
     */
    export enum status {
        PENDING = 'pending',
        PROCESSING = 'processing',
        SUCCESS = 'success',
        FAILED = 'failed',
        REFUNDED = 'refunded',
        PARTIALLY_REFUNDED = 'partially_refunded'
    }
}

export type TransactionsListResponseDto = {
    data: Array<TransactionItemDto>;
    meta: PaginationMetaDto;
};

export type UnregisterTokenDto = {
    /**
     * Уникальный ID устройства для удаления токена
     */
    deviceId: string;
};

export type UpdateAdminBookingDto = {
    /**
     * Новое время начала услуги (ISO 8601 UTC). Без end_time сдвигает запись с сохранением текущей длительности.
     */
    start_time?: string;
    /**
     * Новое время окончания услуги (ISO 8601 UTC). Если передано вместе со start_time — задаёт явную длительность (минимум 15 минут, кратно 15 минутам). Имеет приоритет над пересчётом из услуг.
     */
    end_time?: string;
    /**
     * UUID новой основной услуги
     */
    service_uuid?: string;
    /**
     * UUID поста сервисного центра
     */
    post_uuid?: string;
    /**
     * Массив UUID дополнительных услуг
     */
    additionalServiceUuids?: Array<string>;
    /**
     * Комментарий клиента к бронированию
     */
    client_comment?: string;
};

export type UpdateAdminDto = {
    /**
     * Email администратора
     */
    email?: string;
    /**
     * Имя администратора
     */
    name?: string;
    /**
     * Телефон администратора
     */
    phone?: string;
    /**
     * Новый пароль администратора
     */
    password?: string;
    /**
     * Активен ли аккаунт администратора
     */
    isActive?: boolean;
};

export type UpdateBookingStatusDto = {
    /**
     * Новый статус бронирования
     */
    status: 'pending_confirmation' | 'paid' | 'confirmed' | 'completed' | 'cancelled';
};

export namespace UpdateBookingStatusDto {
    /**
     * Новый статус бронирования
     */
    export enum status {
        PENDING_CONFIRMATION = 'pending_confirmation',
        PAID = 'paid',
        CONFIRMED = 'confirmed',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
}

export type UpdateBookingStatusResponseDto = {
    /**
     * UUID бронирования
     */
    uuid: string;
    /**
     * Новый статус бронирования
     */
    status: string;
    /**
     * Дата и время последнего обновления (ISO 8601)
     */
    updated_at: string;
};

export type UpdateCarDto = {
    /**
     * Марка автомобиля
     */
    make?: string;
    /**
     * Модель автомобиля
     */
    model?: string;
    /**
     * Цвет автомобиля
     */
    color?: string;
    /**
     * Размер шин
     */
    tire_size?: string;
    /**
     * Класс автомобиля (европейская классификация: A, B, C, D, E, F, J, M, S)
     */
    class?: (CarEuropeanClass);
    /**
     * Номерной знак автомобиля
     */
    license_plate?: string;
};

export type UpdateClientProfileDto = {
    /**
     * Имя клиента
     */
    name?: string;
    /**
     * Email клиента
     */
    email?: string;
    /**
     * Настройки уведомлений клиента
     */
    notification_settings?: {
        [key: string]: unknown;
    };
};

export type UpdateContractorDataDto = {
    /**
     * Тип контрагента: legal_entity — юридическое лицо / ИП, individual — физическое лицо (самозанятый).
     */
    contractor_type?: 'legal_entity' | 'individual';
    /**
     * ФИО контрагента (полностью).
     */
    contractor_full_name?: string;
    /**
     * ИНН контрагента: 10 цифр для юрлица, 12 цифр для ИП / физлица.
     */
    contractor_inn?: string;
    /**
     * Телефон контрагента. Формат: +79XXXXXXXXX.
     */
    contractor_phone?: string;
    /**
     * Серия паспорта (4 цифры).
     */
    contractor_passport_series?: string;
    /**
     * Номер паспорта (6 цифр).
     */
    contractor_passport_number?: string;
    /**
     * Кем выдан паспорт.
     */
    contractor_passport_issued_by?: string;
    /**
     * Дата выдачи паспорта в формате YYYY-MM-DD.
     */
    contractor_passport_issue_date?: string;
    /**
     * Дата постановки на учёт в качестве самозанятого (YYYY-MM-DD).
     */
    contractor_self_employed_date?: string;
    /**
     * ИФНС места постановки на учёт.
     */
    contractor_tax_office?: string;
    /**
     * Адрес регистрации контрагента.
     */
    contractor_registration_address?: string;
    /**
     * ИНН банка контрагента (10 цифр).
     */
    contractor_bank_inn?: string;
    /**
     * КПП банка контрагента (9 цифр).
     */
    contractor_bank_kpp?: string;
    /**
     * Идентификатор банка-получателя в СБП. Обязателен для типа individual. Получить список доступных банков через GET /admin/service-centers/:uuid/contractor-data/sbp-banks.
     */
    sbp_member_id?: string;
};

export namespace UpdateContractorDataDto {
    /**
     * Тип контрагента: legal_entity — юридическое лицо / ИП, individual — физическое лицо (самозанятый).
     */
    export enum contractor_type {
        LEGAL_ENTITY = 'legal_entity',
        INDIVIDUAL = 'individual'
    }
}

export type UpdateDiscountDto = {
    title?: string;
    description?: string;
    type?: 'manual' | 'promocode';
    /**
     * Обязателен для type=promocode
     */
    promo_code?: string;
    value_type?: 'percent' | 'fixed';
    /**
     * Для percent — целое 1..100; для fixed — сумма в копейках, >= 1
     */
    value?: number;
    scope?: 'all_centers' | 'selected_centers';
    audience?: 'all' | 'selected_clients';
    platform_percent?: number;
    sto_percent?: number;
    starts_at?: string;
    ends_at?: string;
    is_active?: boolean;
    /**
     * Пусто — без лимита
     */
    max_uses_total?: number;
    /**
     * Пусто — без лимита
     */
    max_uses_per_client?: number;
    /**
     * При scope=selected_centers
     */
    service_center_uuids?: Array<string>;
    /**
     * При audience=selected_clients
     */
    client_uuids?: Array<string>;
    rules?: Array<DiscountRuleDto>;
};

export namespace UpdateDiscountDto {
    export enum type {
        MANUAL = 'manual',
        PROMOCODE = 'promocode'
    }
    export enum value_type {
        PERCENT = 'percent',
        FIXED = 'fixed'
    }
    export enum scope {
        ALL_CENTERS = 'all_centers',
        SELECTED_CENTERS = 'selected_centers'
    }
    export enum audience {
        ALL = 'all',
        SELECTED_CLIENTS = 'selected_clients'
    }
}

export type UpdateEmployeeDto = {
    first_name?: string;
    last_name?: string;
    phone?: string;
    email?: (string) | null;
    position_uuid?: string;
    is_active?: boolean;
};

export type UpdateEmployeePaymentSchemeDto = {
    fix_per_shift?: (number) | null;
    hourly_rate?: (number) | null;
};

export type UpdateFaqDto = {
    [key: string]: unknown;
};

export type UpdateFeedbackSettingsDto = {
    /**
     * Email-адреса для уведомлений о новых обращениях
     */
    notification_emails: Array<string>;
    /**
     * Телефоны админов для push-уведомлений (+7XXXXXXXXXX)
     */
    push_phones: Array<string>;
    /**
     * Включена ли SMS-эскалация
     */
    sms_escalation_enabled: boolean;
    /**
     * Задержка перед SMS-эскалацией (минуты)
     */
    sms_escalation_delay_minutes: number;
    /**
     * Телефоны для SMS-эскалации (+7XXXXXXXXXX)
     */
    sms_escalation_phones: Array<string>;
};

export type UpdateFeedbackStatusDto = {
    /**
     * Новый статус обращения
     */
    status: 'new' | 'in_progress' | 'resolved' | 'closed';
};

export namespace UpdateFeedbackStatusDto {
    /**
     * Новый статус обращения
     */
    export enum status {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        RESOLVED = 'resolved',
        CLOSED = 'closed'
    }
}

export type UpdateGasStationDto = {
    /**
     * Цена газа в каталоге. null — цена неизвестна. Доступность — через fuel_available или null в price_*
     */
    price_gas?: (number) | null;
    /**
     * Цена ДТ в каталоге. null — цена неизвестна
     */
    price_dt?: (number) | null;
    /**
     * Цена АИ-92 в каталоге. null — цена неизвестна
     */
    price_ai_92?: (number) | null;
    /**
     * Цена АИ-95 в каталоге. null — цена неизвестна
     */
    price_ai_95?: (number) | null;
    /**
     * Цена АИ-95+ в каталоге. null — цена неизвестна
     */
    price_ai_95_plus?: (number) | null;
    /**
     * Цена АИ-98 в каталоге. null — цена неизвестна
     */
    price_ai_98?: (number) | null;
    /**
     * Цена АИ-100 в каталоге. null — цена неизвестна
     */
    price_ai_100?: (number) | null;
    /**
     * OSM ID или внешний идентификатор
     */
    osm_id?: string;
    /**
     * Бренд заправки
     */
    brand?: string;
    /**
     * Название заправки
     */
    name?: string;
    /**
     * Адрес
     */
    address?: string;
    /**
     * Широта
     */
    lat?: number;
    /**
     * Долгота
     */
    lon?: number;
    /**
     * Статус
     */
    status?: 'yes' | 'queue' | 'low' | 'no';
    /**
     * Дополнительная информация
     */
    detail?: string;
    /**
     * Размер очереди в минутах. null — неизвестно
     */
    queue_minutes?: (number) | null;
    /**
     * Активна ли заправка
     */
    is_active?: boolean;
    /**
     * Лимит продажи бензина в одни руки, литры. null — без лимита/неизвестно
     */
    per_person_limit_liters_petrol?: (number) | null;
    /**
     * Лимит продажи дизеля в одни руки, литры. null — без лимита/неизвестно
     */
    per_person_limit_liters_dt?: (number) | null;
    /**
     * Доступность видов топлива (отдельно от каталога цен)
     */
    fuel_available?: (FuelAvailabilityDto);
    /**
     * Можно ли заливать в канистры
     */
    canister_refill_allowed?: boolean;
};

export namespace UpdateGasStationDto {
    /**
     * Статус
     */
    export enum status {
        YES = 'yes',
        QUEUE = 'queue',
        LOW = 'low',
        NO = 'no'
    }
}

export type UpdateHelpExecutorDto = {
    name?: string;
    /**
     * Телефон исполнителя в формате E.164 (+79991234567)
     */
    phone?: string;
    vehicle_model?: string;
    vehicle_plate?: string;
    experience_years?: number;
    company?: string;
    enabled?: boolean;
};

export type UpdateHelpOrderDto = {
    customer?: HelpOrderCustomerPatchDto;
    pickup?: HelpPointDto;
    dropoff?: ((HelpPointDto) | null);
    items?: Array<HelpOrderItemPatchDto>;
    prepaid_amount?: number;
    prepaid_status?: 'pending' | 'success' | 'refunded';
    extra_payment_status?: 'pending' | 'success' | 'refunded';
    executor?: ((HelpOrderExecutorPatchDto) | null);
    blocked_wheels?: number;
    hard_to_access?: boolean;
    comment?: string;
};

export namespace UpdateHelpOrderDto {
    export enum prepaid_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
    export enum extra_payment_status {
        PENDING = 'pending',
        SUCCESS = 'success',
        REFUNDED = 'refunded'
    }
}

export type UpdateHelpOrderStatusDto = {
    status: 'awaiting_confirmation' | 'en_route' | 'on_site' | 'in_progress' | 'completed' | 'cancelled';
};

export namespace UpdateHelpOrderStatusDto {
    export enum status {
        AWAITING_CONFIRMATION = 'awaiting_confirmation',
        EN_ROUTE = 'en_route',
        ON_SITE = 'on_site',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled'
    }
}

export type UpdateHelpServiceDto = {
    kind?: 'tow' | 'fuel' | 'jump_start' | 'addon';
    code?: string;
    title?: string;
    description?: string;
    location_title?: (string) | null;
    unit_price?: number;
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    pricing_mode?: 'fixed' | 'per_unit' | 'flexible';
    /**
     * Внешний id услуги у провайдера (LAT service_id и аналоги).
     */
    provider_service_id?: (string) | null;
    unit_label?: string;
    sort_order?: number;
    enabled?: boolean;
    coming_soon?: boolean;
};

export namespace UpdateHelpServiceDto {
    export enum kind {
        TOW = 'tow',
        FUEL = 'fuel',
        JUMP_START = 'jump_start',
        ADDON = 'addon'
    }
    /**
     * fixed — фиксированная цена за заказ; per_unit — цена за единицу; flexible — ориентир «от», итог правит диспетчер.
     */
    export enum pricing_mode {
        FIXED = 'fixed',
        PER_UNIT = 'per_unit',
        FLEXIBLE = 'flexible'
    }
}

export type UpdateLegalDataDto = {
    /**
     * Краткое название магазина в СМС и на 3DS-форме (только латиница, цифры, точка, дефис, underscore, пробел). Используется как billingDescriptor в T-Bank API.
     */
    billing_descriptor?: string;
    /**
     * Полное юридическое наименование организации с ОПФ. Пример: Общество с ограниченной ответственностью «Компания». Используется как fullName в T-Bank API.
     */
    legal_full_name?: string;
    /**
     * Сокращённое наименование организации кириллицей с ОПФ. Пример: ООО «Компания». Используется как name в T-Bank API.
     */
    legal_name?: string;
    /**
     * ИНН организации: 10 цифр для юрлица, 12 цифр для ИП.
     */
    inn?: string;
    /**
     * КПП (9 цифр). Если у организации нет КПП (например, ИП), передавать 000000000.
     */
    kpp?: string;
    /**
     * ОГРН: 13 цифр для юрлица, 15 цифр для ИП.
     */
    ogrn?: string;
    /**
     * Email организации (партнёра магазина).
     */
    legal_email?: string;
    /**
     * Адрес сайта организации.
     */
    site_url?: string;
    /**
     * Почтовый индекс юридического адреса.
     */
    legal_zip?: string;
    /**
     * Трёхбуквенный код страны по ISO 3166 Alpha-3 (для России: RUS).
     */
    legal_country?: string;
    /**
     * Город или населённый пункт юридического адреса.
     */
    legal_city?: string;
    /**
     * Улица и номер дома юридического адреса. Допустимы только символы «.» и «,» из спецсимволов.
     */
    legal_street?: string;
    /**
     * Имя руководителя.
     */
    director_first_name?: string;
    /**
     * Фамилия руководителя.
     */
    director_last_name?: string;
    /**
     * Отчество руководителя.
     */
    director_middle_name?: string;
    /**
     * Контактный телефон руководителя. Формат: +79XXXXXXXXX.
     */
    director_phone?: string;
    /**
     * Гражданство руководителя — трёхбуквенный код ISO 3166 Alpha-3 (для России: RUS).
     */
    director_citizenship?: string;
    /**
     * Расчётный счёт организации (20 цифр). Используется как bankAccount.account в T-Bank API.
     */
    settlement_account?: string;
    /**
     * Корреспондентский счёт (20 цифр). Необязателен.
     */
    correspondent_account?: string;
    /**
     * Полное наименование банка. Используется как bankAccount.bankName в T-Bank API.
     */
    bank_name?: string;
    /**
     * БИК банка (9 цифр). Используется как bankAccount.bik в T-Bank API.
     */
    bik?: string;
    /**
     * Назначение платежа при перечислении возмещения. Поддерживает переменные ${date}, ${rub}, ${kop}. Используется как bankAccount.details в T-Bank API.
     */
    bank_payment_details?: string;
    /**
     * Номер договора с оператором сервиса.
     */
    contract_number?: string;
    /**
     * Дата заключения договора в формате YYYY-MM-DD.
     */
    contract_date?: string;
    /**
     * Номер кабинета / офиса.
     */
    office?: string;
    /**
     * Организационно-правовая форма (ОПФ).
     */
    orgForm?: string;
};

export type UpdateOperatingHoursDto = {
    /**
     * Специальная дата (праздник, выходной, сокращенный день)
     */
    specific_date?: string;
    /**
     * Время открытия (формат HH:mm)
     */
    open_time?: string;
    /**
     * Время закрытия (формат HH:mm)
     */
    close_time?: string;
    /**
     * Флаг выходного дня
     */
    is_closed?: boolean;
    /**
     * Часовой пояс
     */
    timezone?: string;
};

export type UpdatePaymentSchemeServiceDto = {
    rate_type: 'fixed' | 'percent';
    value: number;
};

export namespace UpdatePaymentSchemeServiceDto {
    export enum rate_type {
        FIXED = 'fixed',
        PERCENT = 'percent'
    }
}

export type UpdatePaymentSchemeTemplateDto = {
    name?: string;
    fix_per_shift?: (number) | null;
    hourly_rate?: (number) | null;
    /**
     * Полный набор строк шаблона: что не прислали — удаляется
     */
    services?: Array<PaymentSchemeServiceInputDto>;
    /**
     * Скрыть шаблон из селекта, не удаляя
     */
    is_archived?: boolean;
};

export type UpdatePostDto = {
    /**
     * Доступен ли пост для онлайн записи
     */
    isAvailableForOnlineBooking?: boolean;
};

export type UpdatePostResponseDto = {
    /**
     * UUID поста
     */
    uuid: string;
    /**
     * Порядковый номер поста
     */
    orderNumber: number;
    /**
     * Доступен ли пост для онлайн записи
     */
    isAvailableForOnlineBooking: boolean;
    /**
     * Дата создания
     */
    created_at: string;
};

export type UpdatePushCampaignDto = {
    name?: string;
    title?: string;
    body?: string;
    subtitle?: {
        [key: string]: unknown;
    };
    link_kind?: 'none' | 'service_center' | 'closest' | 'bookings';
    link_service_center_uuid?: {
        [key: string]: unknown;
    };
    target_business_type?: ('car_wash' | 'tire_service') | null;
    audience_mode?: 'all_matching' | 'client_uuids';
    audience_query?: {
        [key: string]: unknown;
    };
    client_uuids?: Array<string>;
    attribution_window_hours?: number;
};

export namespace UpdatePushCampaignDto {
    export enum link_kind {
        NONE = 'none',
        SERVICE_CENTER = 'service_center',
        CLOSEST = 'closest',
        BOOKINGS = 'bookings'
    }
    export enum target_business_type {
        CAR_WASH = 'car_wash',
        TIRE_SERVICE = 'tire_service'
    }
    export enum audience_mode {
        ALL_MATCHING = 'all_matching',
        CLIENT_UUIDS = 'client_uuids'
    }
}

export type UpdateRegularScheduleDto = {
    /**
     * Расписание на понедельник
     */
    monday: (DayScheduleDto);
    /**
     * Расписание на вторник
     */
    tuesday: (DayScheduleDto);
    /**
     * Расписание на среду
     */
    wednesday: (DayScheduleDto);
    /**
     * Расписание на четверг
     */
    thursday: (DayScheduleDto);
    /**
     * Расписание на пятницу
     */
    friday: (DayScheduleDto);
    /**
     * Расписание на субботу
     */
    saturday: (DayScheduleDto);
    /**
     * Расписание на воскресенье
     */
    sunday: (DayScheduleDto);
    /**
     * Часовой пояс сервисного центра
     */
    timezone: string;
};

export type UpdateRoleDto = {
    [key: string]: unknown;
};

export type UpdateServiceCenterDto = {
    /**
     * Название сервисного центра
     */
    name?: string;
    /**
     * Адрес сервисного центра
     */
    address?: string;
    /**
     * Координаты сервисного центра
     */
    location?: (LocationDto);
    /**
     * Описание сервисного центра
     */
    description?: string;
    /**
     * URL логотипа
     */
    logo_url?: string;
    /**
     * Фотогалерея
     */
    photo_gallery_urls?: Array<string>;
    /**
     * Рабочие часы
     */
    working_hours?: {
        [key: string]: unknown;
    };
    /**
     * Контакты
     */
    contacts?: {
        [key: string]: unknown;
    };
    /**
     * Внешний рейтинг
     */
    external_rating?: number;
    /**
     * ИНН юрлица/ИП сервисного центра (10 или 12 цифр)
     */
    inn?: string;
    /**
     * Юридическое наименование сервисного центра
     */
    legal_name?: string;
    /**
     * Опубликован ли сервисный центр (виден клиентам)
     */
    isPublished?: boolean;
    /**
     * Телефон получателя выплат для T-Bank MultiSplit (PaymentRecipientId)
     */
    payment_recipient_phone?: string;
    /**
     * ОГРН
     */
    ogrn?: string;
    /**
     * КПП
     */
    kpp?: string;
    /**
     * Юридический адрес
     */
    legal_address?: string;
    /**
     * ФИО генерального директора
     */
    director_name?: string;
    /**
     * Номер договора
     */
    contract_number?: string;
    /**
     * Дата заключения договора
     */
    contract_date?: string;
    /**
     * Наименование банка
     */
    bank_name?: string;
    /**
     * БИК
     */
    bik?: string;
    /**
     * Корреспондентский счёт
     */
    correspondent_account?: string;
    /**
     * Расчётный счёт
     */
    settlement_account?: string;
};

export type UpdateServiceDto = {
    /**
     * Название услуги
     */
    name?: string;
    /**
     * Описание услуги
     */
    description?: string;
    /**
     * Длительность услуги в минутах
     */
    duration_minutes?: number;
    /**
     * Категория услуги
     */
    category?: string;
    /**
     * Тип бизнеса
     */
    business_type?: 'tire_service' | 'car_wash';
    /**
     * Тип услуги
     */
    service_type?: 'main' | 'additional';
    /**
     * Дополнительные заметки
     */
    notes?: string;
    /**
     * Массив цен для услуги
     */
    servicePrices?: Array<UpdateServicePriceDto>;
};

export namespace UpdateServiceDto {
    /**
     * Тип бизнеса
     */
    export enum business_type {
        TIRE_SERVICE = 'tire_service',
        CAR_WASH = 'car_wash'
    }
    /**
     * Тип услуги
     */
    export enum service_type {
        MAIN = 'main',
        ADDITIONAL = 'additional'
    }
}

export type UpdateServicePriceDto = {
    /**
     * UUID цены (если передан - обновляем существующую)
     */
    uuid?: string;
    /**
     * Тип параметра ценообразования
     */
    parameter_type?: 'simple_car_class' | 'wheel_size';
    /**
     * Значение параметра
     */
    parameter_value?: string;
    /**
     * Цена
     */
    price?: number;
    /**
     * Активность
     */
    is_active?: boolean;
};

export namespace UpdateServicePriceDto {
    /**
     * Тип параметра ценообразования
     */
    export enum parameter_type {
        SIMPLE_CAR_CLASS = 'simple_car_class',
        WHEEL_SIZE = 'wheel_size'
    }
}

export type UpdateSystemSettingEntryDto = {
    /**
     * Ключ настройки
     */
    key: string;
    /**
     * Новое значение настройки
     */
    value: {
        [key: string]: unknown;
    };
};

export type UpdateSystemSettingsDto = {
    /**
     * Настройки для обновления (один или несколько key-value)
     */
    settings: Array<UpdateSystemSettingEntryDto>;
};

export type UpdateTopicDto = {
    [key: string]: unknown;
};

export type UpsertGasStationSubscriptionDto = {
    /**
     * Виды топлива для отслеживания появления в наличии
     */
    watch_fuels: Array<string>;
    /**
     * Уведомить только один раз: после первого уведомления подписка автоматически удаляется
     */
    notify_once?: boolean;
};

export type UserResponseDto = {
    /**
     * UUID пользователя
     */
    uuid: string;
    /**
     * Email пользователя
     */
    email: string;
    /**
     * Телефон пользователя
     */
    phone?: string;
    /**
     * Имя пользователя
     */
    name: string;
    /**
     * Объект роли пользователя
     */
    role: (RoleResponseDto);
    /**
     * Время последнего входа
     */
    lastLogin?: {
        [key: string]: unknown;
    };
};

export type AppGetHelloResponse = (unknown);

export type AppHealthCheckResponse = (unknown);

export type AuthLoginData = {
    requestBody: LoginDto;
};

export type AuthLoginResponse = (AuthResponseDto);

export type AuthLogoutResponse = (LogoutResponseDto);

export type AuthGetCurrentUserResponse = (UserResponseDto);

export type AuthRefreshResponse = (RefreshResponseDto);

export type RolesGetAllResponse = (Array<Role>);

export type RolesCreateData = {
    requestBody: CreateRoleDto;
};

export type RolesCreateResponse = (Role);

export type RolesGetOneData = {
    /**
     * UUID роли
     */
    uuid: string;
};

export type RolesGetOneResponse = (Role);

export type RolesUpdateData = {
    requestBody: UpdateRoleDto;
    /**
     * UUID роли для обновления
     */
    uuid: string;
};

export type RolesUpdateResponse = (Role);

export type RolesDeleteData = {
    /**
     * UUID роли для уда��ения
     */
    uuid: string;
};

export type RolesDeleteResponse = (unknown);

export type ClientAuthSendCodeData = {
    requestBody: SendCodeDto;
};

export type ClientAuthSendCodeResponse = (unknown);

export type ClientAuthLoginData = {
    requestBody: ClientLoginDto;
};

export type ClientAuthLoginResponse = (ClientAuthResponseDto);

export type ClientAuthRefreshData = {
    requestBody: RefreshDto;
};

export type ClientAuthRefreshResponse = (ClientAuthResponseDto);

export type ClientAuthRegisterData = {
    requestBody: RegisterDto;
};

export type ClientAuthRegisterResponse = (ClientAuthResponseDto);

export type ClientAuthSetPhoneData = {
    requestBody: SetPhoneDto;
};

export type ClientAuthSetPhoneResponse = (ClientAuthResponseDto);

export type AdminAuthSendCodeData = {
    requestBody: AdminSendCodeDto;
};

export type AdminAuthSendCodeResponse = (AdminSendCodeResponseDto);

export type AdminAuthLoginData = {
    requestBody: AdminLoginDto;
};

export type AdminAuthLoginResponse = (AdminAuthResponseDto);

export type AdminAuthExchangeImpersonationCodeData = {
    requestBody: ExchangeImpersonationCodeDto;
};

export type AdminAuthExchangeImpersonationCodeResponse = (AdminAuthResponseDto);

export type ClientGetMeResponse = (ClientResponseDto);

export type ClientUpdateMeData = {
    requestBody: UpdateClientProfileDto;
};

export type ClientUpdateMeResponse = (ClientResponseDto);

export type ClientRequestDeleteAccountResponse = ({
    message?: string;
});

export type ClientListCarsResponse = (Array<CarResponseDto>);

export type ClientCreateCarData = {
    requestBody: CreateCarDto;
};

export type ClientCreateCarResponse = (CarResponseDto);

export type ClientGetCarData = {
    /**
     * Уникальный идентификатор автомобиля
     */
    carUuid: string;
};

export type ClientGetCarResponse = (CarResponseDto);

export type ClientUpdateCarData = {
    /**
     * Уникальный идентификатор автомобиля
     */
    carUuid: string;
    requestBody: UpdateCarDto;
};

export type ClientUpdateCarResponse = (CarResponseDto);

export type ClientDeleteCarData = {
    /**
     * Уникальный идентификатор автомобиля
     */
    carUuid: string;
};

export type ClientDeleteCarResponse = (void);

export type ClientListBookingsResponse = (unknown);

export type ClientConfirmDeleteAccountData = {
    requestBody: ConfirmDeleteAccountDto;
};

export type ClientConfirmDeleteAccountResponse = (void);

export type ClientRequestDeleteAccountByPhoneData = {
    requestBody: RequestAccountDeletionByPhoneDto;
};

export type ClientRequestDeleteAccountByPhoneResponse = ({
    message?: string;
});

export type ClientConfirmDeleteAccountByPhoneData = {
    requestBody: ConfirmAccountDeletionByPhoneDto;
};

export type ClientConfirmDeleteAccountByPhoneResponse = (void);

export type AdminSearchClientsData = {
    /**
     * Количество результатов
     */
    limit?: number;
    /**
     * Частичный или полный номер телефона для поиска (минимум 3 цифры)
     */
    phone: string;
};

export type AdminSearchClientsResponse = (Array<ClientSearchResultDto>);

export type AdminFindOrCreateClientData = {
    requestBody: AdminFindOrCreateClientDto;
};

export type AdminFindOrCreateClientResponse = (AdminFindOrCreateClientResponseDto);

export type AdminCreateOrUpdateCarData = {
    /**
     * UUID клиента
     */
    clientUuid: string;
    requestBody: AdminCreateOrUpdateCarDto;
};

export type AdminCreateOrUpdateCarResponse = (AdminCarResponseDto);

export type SuperadminListClientsData = {
    /**
     * Количество бронирований за месяц ≥ значения
     */
    filterBookingsCountGte?: number;
    /**
     * Количество бронирований за месяц ≤ значения
     */
    filterBookingsCountLte?: number;
    /**
     * Расходы за месяц ≥ значения (руб.)
     */
    filterTotalSpentGte?: number;
    /**
     * Расходы за месяц ≤ значения (руб.)
     */
    filterTotalSpentLte?: number;
    /**
     * Элементов на странице (по умолчанию 20, макс 100)
     */
    limit?: number;
    /**
     * Месяц (1-12). Если передан вместе с year — метрики считаются за период
     */
    month?: number;
    /**
     * Страница (по умолчанию 1)
     */
    page?: number;
    /**
     * Поиск по имени, телефону или email клиента
     */
    q?: string;
    /**
     * Список UUID сервисных центров через запятую. Оставляет клиентов, у которых есть бронирования в выбранных СЦ
     */
    serviceCenterIds?: string;
    /**
     * Сортировка: поле или -поле для DESC. Пример: -totalSpent,created_at. Доступные поля: bookingsCount, totalSpent, created_at
     */
    sort?: string;
    /**
     * Год. Если передан вместе с month — метрики считаются за период
     */
    year?: number;
};

export type SuperadminListClientsResponse = (SuperadminClientListResponseDto);

export type SuperadminGetClientsSummaryData = {
    /**
     * Месяц (1-12). Передаётся при выборе месяца
     */
    month?: number;
    /**
     * Поиск по имени/телефону/email клиента — ограничивает выборку, по которой считаются метрики
     */
    q?: string;
    /**
     * Список UUID сервисных центров через запятую. Ограничивает клиентов, по которым считаются метрики
     */
    serviceCenterIds?: string;
    /**
     * Номер недели в году (1-53). Передаётся при выборе недели
     */
    week?: number;
    /**
     * Год. Передаётся при выборе месяца или года
     */
    year?: number;
};

export type SuperadminGetClientsSummaryResponse = (SuperadminClientSummaryDto);

export type SuperadminGroupClientsData = {
    groupBy: string;
    limit?: number;
    metrics?: string;
};

export type SuperadminGroupClientsResponse = (GroupedResponseDto);

export type SuperadminGetClientData = {
    /**
     * UUID клиента
     */
    uuid: string;
};

export type SuperadminGetClientResponse = (SuperadminClientDetailDto);

export type SuperadminGetClientStatsData = {
    /**
     * UUID клиента
     */
    uuid: string;
    /**
     * Год (2000–2100)
     */
    year: number;
};

export type SuperadminGetClientStatsResponse = (ClientStatsResponseDto);

export type SuperadminGetClientTransactionsData = {
    /**
     * Начало периода (ISO 8601)
     */
    filterDateFromEq?: string;
    /**
     * Конец периода (ISO 8601)
     */
    filterDateToEq?: string;
    /**
     * Метод оплаты
     */
    filterPaymentMethodEq?: 'card' | 'sbp' | 'cash';
    /**
     * Статус операции
     */
    filterStatusEq?: 'pending' | 'processing' | 'success' | 'failed' | 'refunded' | 'partially_refunded';
    /**
     * Тип операции
     */
    filterTypeEq?: 'payment' | 'refund';
    /**
     * Элементов на странице
     */
    limit?: number;
    /**
     * Страница
     */
    page?: number;
    /**
     * Поиск по UUID бронирования
     */
    q?: string;
    /**
     * Сортировка: date, -date, amount, -amount
     */
    sort?: string;
    /**
     * UUID клиента
     */
    uuid: string;
};

export type SuperadminGetClientTransactionsResponse = (ClientTransactionsListResponseDto);

export type SuperadminGetClientBookingsData = {
    /**
     * Начало периода (ISO 8601)
     */
    filterDateFromEq?: string;
    /**
     * Конец периода (ISO 8601)
     */
    filterDateToEq?: string;
    /**
     * Статус оплаты
     */
    filterPaymentStatusEq?: 'unpaid' | 'pending' | 'paid' | 'refunded' | 'partially_refunded';
    /**
     * Статус бронирования
     */
    filterStatusEq?: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
    /**
     * Элементов на странице
     */
    limit?: number;
    /**
     * Страница
     */
    page?: number;
    /**
     * Поиск по названию услуги, СЦ, марке/модели авто
     */
    q?: string;
    /**
     * Сортировка: start_time, -start_time, total_cost, -total_cost, created_at, -created_at
     */
    sort?: string;
    /**
     * UUID клиента
     */
    uuid: string;
};

export type SuperadminGetClientBookingsResponse = (ClientBookingsListResponseDto);

export type ServiceCenterListData = {
    /**
     * Фильтр по типу бизнеса сервисного центра
     */
    businessType?: 'tire_service' | 'car_wash';
    /**
     * Категория услуг для фильтрации
     */
    category?: string;
    /**
     * Максимальная цена услуги
     */
    endPrice?: number;
    /**
     * Фильтр по работающим в данный момент центрам
     */
    isOpenNow?: boolean;
    /**
     * Широта местоположения пользователя
     */
    lat?: number;
    /**
     * Долгота местоположения пользователя
     */
    lon?: number;
    /**
     * Минимальный рейтинг сервисного центра
     */
    minRating?: number;
    /**
     * Показывать только избранные сервисные центры
     */
    onlyFavorites?: boolean;
    /**
     * Радиус поиска в метрах
     */
    radius?: number;
    /**
     * Поисковый запрос для фильтрации по названию или адресу сервисного центра
     */
    search?: string;
    /**
     * Критерий сортировки результатов
     */
    sortBy?: 'distance' | 'rating';
    /**
     * Минимальная цена услуги
     */
    startPrice?: number;
    /**
     * Показывать только сервисные центры со свободными слотами (с учетом фильтров category)
     */
    withFreeSlots?: boolean;
};

export type ServiceCenterListResponse = (Array<ReducedServiceCenterResponseDto>);

export type ServiceCenterGetOneData = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
};

export type ServiceCenterGetOneResponse = (DetailedServiceCenterResponseDto);

export type ServiceCenterGetSlotsData = {
    /**
     * Список UUID дополнительных услуг для расчета общей длительности
     */
    additionalServiceUuids?: Array<string>;
    /**
     * Дата для поиска доступных слотов (используется если не указаны dateFrom/dateTo)
     */
    date?: string;
    /**
     * Начальная дата диапазона для поиска слотов
     */
    dateFrom?: string;
    /**
     * Конечная дата диапазона для поиска слотов
     */
    dateTo?: string;
    /**
     * Флаг клиентского запроса. Если true - возвращаются только слоты постов с isAvailableForOnlineBooking=true. Если false или не указан - возвращаются все слоты (для админа)
     */
    isClient?: boolean;
    /**
     * UUID поста сервисного центра для фильтрации слотов. Если указан - возвращаются слоты только для конкретного поста. Если не указан - слот считается свободным, если хотя бы один пост свободен
     */
    serviceCenterPostUuid?: string;
    /**
     * Уникальный идентификатор услуги
     */
    serviceUuid: string;
    /**
     * Шаг расчёта слотов в минутах. По умолчанию 60 минут (1 час). Минимум 15, максимум 120 минут
     */
    step?: number;
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
};

export type ServiceCenterGetSlotsResponse = (Array<string>);

export type ServiceCenterToggleFavoriteData = {
    /**
     * Уникальный идентификатор сервисного центра
     */
    uuid: string;
};

export type ServiceCenterToggleFavoriteResponse = ({
    /**
     * Новый статус избранного
     */
    isFavorite?: boolean;
});

export type AdminGetServiceCenterPostsData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetServiceCenterPostsResponse = (ServiceCenterPostsListResponseDto);

export type AdminCreateServiceCenterPostData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminCreateServiceCenterPostResponse = (CreatePostResponseDto);

export type AdminDeleteServiceCenterPostData = {
    /**
     * UUID поста для удаления
     */
    postUuid: string;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminDeleteServiceCenterPostResponse = (DeletePostResponseDto);

export type AdminUpdateServiceCenterPostData = {
    /**
     * UUID поста
     */
    postUuid: string;
    requestBody: UpdatePostDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminUpdateServiceCenterPostResponse = (UpdatePostResponseDto);

export type AdminGetServiceCenterLegalDataData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetServiceCenterLegalDataResponse = (LegalDataResponseDto);

export type AdminUpdateServiceCenterLegalDataData = {
    requestBody: UpdateLegalDataDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminUpdateServiceCenterLegalDataResponse = (LegalDataResponseDto);

export type AdminGetServiceCenterContractorDataData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetServiceCenterContractorDataResponse = (unknown);

export type AdminUpdateServiceCenterContractorDataData = {
    requestBody: UpdateContractorDataDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminUpdateServiceCenterContractorDataResponse = (unknown);

export type AdminGetSbpBanksData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetSbpBanksResponse = (unknown);

export type AdminGenerateContractData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGenerateContractResponse = (unknown);

export type AdminDownloadContractData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminDownloadContractResponse = (unknown);

export type AdminGetContractLinkData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetContractLinkResponse = (unknown);

export type AdminRegisterServiceCenterInTBankData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminRegisterServiceCenterInTBankResponse = (unknown);

export type AdminGetServiceCenterTBankRegistrationStatusData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminGetServiceCenterTBankRegistrationStatusResponse = (unknown);

export type SuperadminListServiceCentersData = {
    /**
     * Количество бронирований за месяц ≥ значения
     */
    filterBookingsCountGte?: number;
    /**
     * Количество бронирований за месяц ≤ значения
     */
    filterBookingsCountLte?: number;
    /**
     * Комиссия за месяц ≥ значения (руб.)
     */
    filterCommissionGte?: number;
    /**
     * Комиссия за месяц ≤ значения (руб.)
     */
    filterCommissionLte?: number;
    /**
     * Баланс к выплате ≥ значения (руб.)
     */
    filterPendingPayoutGte?: number;
    /**
     * Баланс к выплате ≤ значения (руб.)
     */
    filterPendingPayoutLte?: number;
    /**
     * Рейтинг ≥ значения
     */
    filterRatingGte?: number;
    /**
     * Рейтинг ≤ значения
     */
    filterRatingLte?: number;
    /**
     * Выручка за месяц ≥ значения (руб.)
     */
    filterRevenueGte?: number;
    /**
     * Выручка за месяц ≤ значения (руб.)
     */
    filterRevenueLte?: number;
    /**
     * Фильтр по статусу публикации
     */
    filterStatusEq?: 'active' | 'inactive';
    /**
     * Элементов на странице (по умолчанию 20, макс 100)
     */
    limit?: number;
    /**
     * Месяц (1-12). Если не передан — метрики возвращаются нулями
     */
    month?: number;
    /**
     * Страница (по умолчанию 1)
     */
    page?: number;
    /**
     * Поиск по названию или адресу сервисного центра
     */
    q?: string;
    /**
     * Сортировка: поле или -поле для DESC. Пример: -revenue,created_at. Доступные поля: bookingsCount, rating, revenue, commission, pendingPayout, created_at
     */
    sort?: string;
    /**
     * Год. Если не передан — метрики возвращаются нулями
     */
    year?: number;
};

export type SuperadminListServiceCentersResponse = (SuperadminServiceCenterListResponseDto);

export type SuperadminCreateServiceCenterData = {
    requestBody: CreateServiceCenterDto;
};

export type SuperadminCreateServiceCenterResponse = (unknown);

export type SuperadminGetServiceCentersSummaryData = {
    /**
     * Комиссия за период ≥ значения (руб.)
     */
    filterCommissionGte?: number;
    /**
     * Комиссия за период ≤ значения (руб.)
     */
    filterCommissionLte?: number;
    /**
     * Баланс к выплате ≥ значения (руб.)
     */
    filterPendingPayoutGte?: number;
    /**
     * Баланс к выплате ≤ значения (руб.)
     */
    filterPendingPayoutLte?: number;
    /**
     * Рейтинг ≥ значения
     */
    filterRatingGte?: number;
    /**
     * Рейтинг ≤ значения
     */
    filterRatingLte?: number;
    /**
     * Выручка за период ≥ значения (руб.)
     */
    filterRevenueGte?: number;
    /**
     * Выручка за период ≤ значения (руб.)
     */
    filterRevenueLte?: number;
    /**
     * Фильтр по статусу публикации
     */
    filterStatusEq?: 'active' | 'inactive';
    /**
     * Месяц (1-12). Передаётся при выборе месяца
     */
    month?: number;
    /**
     * Поиск по названию СЦ — ограничивает выборку, по которой считаются метрики
     */
    q?: string;
    /**
     * Номер недели в году (1-53). Передаётся при выборе недели
     */
    week?: number;
    /**
     * Год. Передаётся при выборе месяца или года
     */
    year?: number;
};

export type SuperadminGetServiceCentersSummaryResponse = (SuperadminServiceCenterSummaryDto);

export type SuperadminGetServiceCenterStatsData = {
    /**
     * UUID сервисного центра
     */
    uuid: string;
    /**
     * Год, за который считаются метрики (2020–2100)
     */
    year: number;
};

export type SuperadminGetServiceCenterStatsResponse = (ScStatsResponseDto);

export type SuperadminImpersonateServiceCenterData = {
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminImpersonateServiceCenterResponse = (ImpersonationCodeResponseDto);

export type SuperadminGetServiceCenterData = {
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminGetServiceCenterResponse = (SuperadminServiceCenterDetailDto);

export type SuperadminUpdateServiceCenterData = {
    requestBody: UpdateServiceCenterDto;
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminUpdateServiceCenterResponse = (unknown);

export type SuperadminDeleteServiceCenterData = {
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminDeleteServiceCenterResponse = (unknown);

export type SuperadminGetServiceCenterTransactionsData = {
    /**
     * Дата начала периода (ISO 8601)
     */
    filterDateFromEq?: string;
    /**
     * Дата окончания периода (ISO 8601)
     */
    filterDateToEq?: string;
    /**
     * Фильтр по методу оплаты (только для платежей)
     */
    filterPaymentMethodEq?: 'card' | 'sbp' | 'cash';
    /**
     * Фильтр по статусу
     */
    filterStatusEq?: 'pending' | 'processing' | 'success' | 'failed' | 'refunded' | 'partially_refunded';
    /**
     * Фильтр по типу операции
     */
    filterTypeEq?: 'payment' | 'refund' | 'payout';
    /**
     * Элементов на странице (по умолчанию 20)
     */
    limit?: number;
    /**
     * Страница (по умолчанию 1)
     */
    page?: number;
    /**
     * Поиск по описанию операции или UUID бронирования
     */
    q?: string;
    /**
     * Сортировка: поле или -поле для DESC. Доступные поля: date, amount
     */
    sort?: string;
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminGetServiceCenterTransactionsResponse = (TransactionsListResponseDto);

export type SuperadminGetServiceCenterBookingsData = {
    /**
     * Начало периода (ISO 8601)
     */
    filterDateFromEq?: string;
    /**
     * Конец периода (ISO 8601)
     */
    filterDateToEq?: string;
    /**
     * Фильтр по статусу оплаты
     */
    filterPaymentStatusEq?: 'pending' | 'paid' | 'refunded' | 'partially_refunded';
    /**
     * Фильтр по статусу бронирования
     */
    filterStatusEq?: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
    /**
     * Элементов на странице (по умолчанию 20)
     */
    limit?: number;
    /**
     * Страница (по умолчанию 1)
     */
    page?: number;
    /**
     * Поиск по имени/телефону клиента, названию услуги
     */
    q?: string;
    /**
     * Сортировка: поле или -поле для DESC. Доступные поля: start_time, total_cost, created_at, status
     */
    sort?: string;
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminGetServiceCenterBookingsResponse = (BookingsListResponseDto);

export type SuperadminGetServiceCenterPayoutsData = {
    /**
     * Начало периода (ISO 8601)
     */
    filterDateFromEq?: string;
    /**
     * Конец периода (ISO 8601)
     */
    filterDateToEq?: string;
    /**
     * Фильтр по статусу выплаты
     */
    filterStatusEq?: 'pending' | 'processing' | 'success' | 'failed';
    /**
     * Элементов на странице (по умолчанию 20)
     */
    limit?: number;
    /**
     * Страница (по умолчанию 1)
     */
    page?: number;
    /**
     * UUID сервисного центра
     */
    uuid: string;
};

export type SuperadminGetServiceCenterPayoutsResponse = (PayoutsListResponseDto);

export type SuperadminListServiceCenterAdminsData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type SuperadminListServiceCenterAdminsResponse = (unknown);

export type SuperadminCreateServiceCenterAdminData = {
    requestBody: CreateAdminDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type SuperadminCreateServiceCenterAdminResponse = (unknown);

export type SuperadminGetServiceCenterAdminData = {
    /**
     * UUID администратора
     */
    adminUuid: string;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type SuperadminGetServiceCenterAdminResponse = (unknown);

export type SuperadminUpdateServiceCenterAdminData = {
    /**
     * UUID администратора
     */
    adminUuid: string;
    requestBody: UpdateAdminDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type SuperadminUpdateServiceCenterAdminResponse = (unknown);

export type SuperadminDeleteServiceCenterAdminData = {
    /**
     * UUID администратора
     */
    adminUuid: string;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type SuperadminDeleteServiceCenterAdminResponse = (unknown);

export type SuperadminGetPayoutDetailData = {
    /**
     * UUID выплаты
     */
    uuid: string;
};

export type SuperadminGetPayoutDetailResponse = (SuperadminPayoutDetailResponseDto);

export type SuperadminPayoutRequestData = {
    requestBody: PayoutRequestDto;
};

export type SuperadminPayoutRequestResponse = (PayoutRequestResponseDto);

export type SuperadminPayoutConfirmData = {
    requestBody: PayoutConfirmDto;
};

export type SuperadminPayoutConfirmResponse = (PayoutConfirmResponseDto);

export type OperatingHoursGetAllData = {
    /**
     * Фильтр по месяцу для специальных дат (формат YYYY-MM)
     */
    month?: string;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
    /**
     * Фильтр по типу расписания
     */
    type?: 'regular' | 'special';
};

export type OperatingHoursGetAllResponse = (OperatingHoursListResponseDto);

export type OperatingHoursUpdateRegularData = {
    requestBody: UpdateRegularScheduleDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type OperatingHoursUpdateRegularResponse = (Array<OperatingHoursResponseDto>);

export type OperatingHoursCreateSpecialData = {
    requestBody: CreateSpecialDateDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type OperatingHoursCreateSpecialResponse = (OperatingHoursResponseDto);

export type OperatingHoursUpdateData = {
    requestBody: UpdateOperatingHoursDto;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
    /**
     * UUID записи времени работы
     */
    uuid: string;
};

export type OperatingHoursUpdateResponse = (OperatingHoursResponseDto);

export type OperatingHoursDeleteData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
    /**
     * UUID записи времени работы
     */
    uuid: string;
};

export type OperatingHoursDeleteResponse = (void);

export type PaymentsControllerPaymentSuccessData = {
    paymentId: string;
    paymentUuid: string;
};

export type PaymentsControllerPaymentSuccessResponse = (unknown);

export type PaymentsControllerPaymentFailData = {
    code: string;
    error: string;
    errorCode: string;
    message: string;
};

export type PaymentsControllerPaymentFailResponse = (unknown);

export type PaymentsControllerHandleTBankWebhookData = {
    requestBody: TBankWebhookDto;
};

export type PaymentsControllerHandleTBankWebhookResponse = (unknown);

export type PaymentsControllerGetAllPaymentsResponse = (Array<PaymentResponseDto>);

export type PaymentsControllerInitPaymentData = {
    requestBody: InitPaymentDto;
};

export type PaymentsControllerInitPaymentResponse = (InitPaymentResponseDto);

export type PaymentsControllerGetPaymentStatusData = {
    uuid: string;
};

export type PaymentsControllerGetPaymentStatusResponse = (PaymentStatusResponseDto);

export type PaymentsControllerCancelPaymentData = {
    requestBody: CancelPaymentDto;
    uuid: string;
};

export type PaymentsControllerCancelPaymentResponse = (CancelPaymentResponseDto);

export type SuperadminGroupPaymentsData = {
    groupBy: string;
    limit?: number;
    metrics?: string;
};

export type SuperadminGroupPaymentsResponse = (GroupedResponseDto);

export type SuperadminListPaymentsResponse = (unknown);

export type SuperadminGetPaymentEventsData = {
    /**
     * UUID платежа
     */
    uuid: string;
};

export type SuperadminGetPaymentEventsResponse = (PaymentEventsResponseDto);

export type SuperadminGetPaymentDetailData = {
    /**
     * UUID платежа
     */
    uuid: string;
};

export type SuperadminGetPaymentDetailResponse = (SuperadminPaymentDetailResponseDto);

export type SuperadminTriggerPayoutData = {
    /**
     * UUID платежа
     */
    uuid: string;
};

export type SuperadminTriggerPayoutResponse = (unknown);

export type ReceiptsControllerHandleWebhookData = {
    contentHmac: string;
    xContentHmac: string;
};

export type ReceiptsControllerHandleWebhookResponse = (unknown);

export type ReceiptsControllerGetReceiptsByPaymentData = {
    paymentUuid: string;
};

export type ReceiptsControllerGetReceiptsByBookingData = {
    bookingUuid: string;
};

export type RegisterNotificationTokenData = {
    requestBody: RegisterTokenDto;
};

export type RegisterNotificationTokenResponse = ({
    success?: boolean;
    message?: string;
});

export type UnregisterNotificationTokenData = {
    requestBody: UnregisterTokenDto;
};

export type UnregisterNotificationTokenResponse = ({
    success?: boolean;
    message?: string;
});

export type GetNotificationSettingsResponse = (NotificationSettingsDto);

export type UpdateNotificationSettingsData = {
    requestBody: NotificationSettingsDto;
};

export type UpdateNotificationSettingsResponse = (NotificationSettingsDto);

export type GetNotificationsData = {
    /**
     * Фильтр по прочитанным уведомлениям (true/false)
     */
    isRead?: boolean;
    /**
     * Количество элементов на странице
     */
    limit?: number;
    /**
     * Номер страницы (начиная с 1)
     */
    page?: number;
    /**
     * Фильтр по типу уведомления
     */
    type?: 'new_booking' | 'booking_cancelled' | 'status_change' | 'booking_updated' | 'feedback' | 'gas_station_fuel_available' | 'promotion';
};

export type GetNotificationsResponse = (NotificationsListResponseDto);

export type MarkNotificationAsReadData = {
    uuid: string;
};

export type MarkNotificationAsReadResponse = (NotificationResponseDto);

export type MarkAllNotificationsAsReadResponse = ({
    updated?: number;
});

export type GetUnreadNotificationsCountResponse = ({
    count?: number;
});

export type SuperadminListPushableClientsData = {
    limit?: number;
    page?: number;
    /**
     * Поиск по имени, телефону или email
     */
    q?: string;
    /**
     * Сортировка: created_at, name, -created_at, -name
     */
    sort?: string;
};

export type SuperadminListPushableClientsResponse = (SuperadminPushableClientsListResponseDto);

export type SuperadminSendPushNotificationsData = {
    requestBody: SuperadminSendPushNotificationsDto;
};

export type SuperadminSendPushNotificationsResponse = (SuperadminSendPushNotificationsResponseDto);

export type SuperadminPushCampaignAudiencePreviewData = {
    audienceMode?: string;
    clientUuids?: Array<unknown>;
    q?: string;
};

export type SuperadminPushCampaignAudiencePreviewResponse = (unknown);

export type SuperadminListPushCampaignsData = {
    limit: number;
    page: number;
    q: string;
    sort: string;
    status: string;
};

export type SuperadminListPushCampaignsResponse = (unknown);

export type SuperadminCreatePushCampaignData = {
    requestBody: PushCampaignWriteDto;
};

export type SuperadminCreatePushCampaignResponse = (unknown);

export type SuperadminExportPushCampaignRecipientsData = {
    uuid: string;
};

export type SuperadminExportPushCampaignRecipientsResponse = (unknown);

export type SuperadminListPushCampaignRecipientsData = {
    funnelStage: string;
    limit: number;
    opened: string;
    page: number;
    q: string;
    status: string;
    uuid: string;
};

export type SuperadminListPushCampaignRecipientsResponse = (unknown);

export type SuperadminGetPushCampaignData = {
    uuid: string;
};

export type SuperadminGetPushCampaignResponse = (unknown);

export type SuperadminUpdatePushCampaignData = {
    requestBody: UpdatePushCampaignDto;
    uuid: string;
};

export type SuperadminUpdatePushCampaignResponse = (unknown);

export type SuperadminSchedulePushCampaignData = {
    requestBody: SchedulePushCampaignDto;
    uuid: string;
};

export type SuperadminSchedulePushCampaignResponse = (unknown);

export type SuperadminSendPushCampaignNowData = {
    uuid: string;
};

export type SuperadminSendPushCampaignNowResponse = (unknown);

export type SuperadminCancelPushCampaignData = {
    uuid: string;
};

export type SuperadminCancelPushCampaignResponse = (unknown);

export type SuperadminDuplicatePushCampaignData = {
    uuid: string;
};

export type SuperadminDuplicatePushCampaignResponse = (unknown);

export type SuperadminTestPushCampaignData = {
    requestBody: TestPushCampaignDto;
    uuid: string;
};

export type SuperadminTestPushCampaignResponse = (unknown);

export type RecordPushCampaignEventData = {
    requestBody: CampaignEventDto;
};

export type RecordPushCampaignEventResponse = (unknown);

export type BookingCreateData = {
    requestBody: CreateBookingDto;
};

export type BookingCreateResponse = (BookingResponseDto);

export type BookingListData = {
    /**
     * Количество записей для возврата
     */
    limit?: number;
    /**
     * Смещение для пагинации
     */
    offset?: number;
};

export type BookingListResponse = (Array<BookingResponseDto>);

export type BookingGetOneData = {
    /**
     * Уникальный идентификатор бронирования
     */
    uuid: string;
};

export type BookingGetOneResponse = (DetailedBookingResponseDto);

export type BookingCancelData = {
    /**
     * Уникальный идентификатор бронирования
     */
    uuid: string;
};

export type BookingCancelResponse = (BookingResponseDto);

export type BookingGetPaymentData = {
    /**
     * Уникальный идентификатор бронирования
     */
    uuid: string;
};

export type BookingGetPaymentResponse = (BookingPaymentResponseDto);

export type AdminBookingsGetListData = {
    /**
     * Начало диапазона дат (ISO 8601)
     */
    dateFrom: string;
    /**
     * Конец диапазона дат (ISO 8601)
     */
    dateTo: string;
    /**
     * Количество записей (default: 100)
     */
    limit?: number;
    /**
     * Смещение для пагинации (default: 0)
     */
    offset?: number;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
    /**
     * Массив статусов для фильтрации: pending_confirmation, confirmed, completed, cancelled
     */
    status?: Array<unknown[]>;
};

export type AdminBookingsGetListResponse = (AdminBookingListResponseDto);

export type AdminCreateBookingData = {
    requestBody: AdminCreateBookingDto;
};

export type AdminCreateBookingResponse = (AdminCreateBookingResponseDto);

export type AdminBookingsGetPendingData = {
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminBookingsGetPendingResponse = (AdminBookingListResponseDto);

export type AdminBookingsGetOneData = {
    /**
     * UUID бронирования
     */
    uuid: string;
};

export type AdminBookingsGetOneResponse = (DetailedBookingResponseDto);

export type AdminBookingsUpdateData = {
    requestBody: UpdateAdminBookingDto;
    /**
     * UUID бронирования
     */
    uuid: string;
};

export type AdminBookingsUpdateResponse = (DetailedBookingResponseDto);

export type AdminBookingsUpdateStatusData = {
    requestBody: UpdateBookingStatusDto;
    /**
     * UUID бронирования
     */
    uuid: string;
};

export type AdminBookingsUpdateStatusResponse = (UpdateBookingStatusResponseDto);

export type AdminBookingsConfirmByCodeData = {
    requestBody: ConfirmBookingDto;
    /**
     * UUID бронирования
     */
    uuid: string;
};

export type AdminBookingsConfirmByCodeResponse = (ConfirmBookingResponseDto);

export type MasterBookingsGetListData = {
    /**
     * Начало диапазона дат (ISO 8601). Опционально, если не указано — ограничений по начальной дате нет
     */
    dateFrom?: string;
    /**
     * Конец диапазона дат (ISO 8601). Опционально, если не указано — ограничений по конечной дате нет
     */
    dateTo?: string;
    /**
     * Количество записей (default: 100, max: 200)
     */
    limit?: number;
    /**
     * Смещение для пагинации (default: 0)
     */
    offset?: number;
    /**
     * UUID сервисного центра для фильтрации (опционально — если не указан, возвращаются бронирования всех СЦ контрагента)
     */
    serviceCenterUuid?: string;
    /**
     * Поле сортировки
     */
    sortBy?: 'start_time' | 'total_cost' | 'created_at' | 'status';
    /**
     * Направление сортировки
     */
    sortOrder?: 'ASC' | 'DESC';
    /**
     * Массив статусов для фильтрации: pending_confirmation, confirmed, completed, cancelled
     */
    status?: Array<unknown[]>;
};

export type MasterBookingsGetListResponse = (AdminBookingListResponseDto);

export type MasterBookingsConfirmByCodeData = {
    requestBody: ConfirmBookingDto;
    /**
     * UUID бронирования
     */
    uuid: string;
};

export type MasterBookingsConfirmByCodeResponse = (ConfirmBookingResponseDto);

export type SuperadminGroupBookingsData = {
    groupBy: string;
    limit?: number;
    metrics?: string;
};

export type SuperadminGroupBookingsResponse = (GroupedResponseDto);

export type SuperadminListBookingsResponse = (unknown);

export type CarsControllerGetMakesData = {
    /**
     * Количество элементов на странице
     */
    limit?: number;
    /**
     * Номер страницы (начинается с 1)
     */
    page?: number;
};

export type CarsControllerGetMakesResponse = ({
    data?: Array<{
        id?: string;
        name?: string;
        cyrillicName?: string;
        numericId?: number;
        yearFrom?: number;
        yearTo?: number;
        popular?: number;
        country?: string;
        updatedAt?: string;
    }>;
    meta?: {
        page?: number;
        limit?: number;
        total?: number;
        totalPages?: number;
        hasNextPage?: boolean;
        hasPrevPage?: boolean;
    };
});

export type CarsControllerGetModelsByMakeIdData = {
    /**
     * Идентификатор марки автомобиля
     */
    id: string;
    /**
     * Количество элементов на странице
     */
    limit?: number;
    /**
     * Номер страницы (начинается с 1)
     */
    page?: number;
};

export type CarsControllerGetModelsByMakeIdResponse = ({
    data?: Array<{
        id?: string;
        markId?: string;
        name?: string;
        cyrillicName?: string;
        yearFrom?: number;
        yearTo?: number;
        class?: string;
        updatedAt?: string;
    }>;
    meta?: {
        page?: number;
        limit?: number;
        total?: number;
        totalPages?: number;
        hasNextPage?: boolean;
        hasPrevPage?: boolean;
    };
});

export type AdminSearchCarsData = {
    /**
     * UUID клиента для фильтрации по конкретному клиенту
     */
    clientUuid?: string;
    /**
     * Частичный или полный номер автомобиля (минимум 2 символа). Опционально, если передан client_uuid
     */
    licensePlate?: string;
    /**
     * Количество результатов
     */
    limit?: number;
};

export type AdminSearchCarsResponse = (Array<CarSearchResultDto>);

export type AdminServicesGetAllData = {
    /**
     * Тип бизнеса (мойка или шиномонтаж)
     */
    businessType?: 'tire_service' | 'car_wash';
    /**
     * Категория услуги
     */
    category?: string;
    /**
     * Фильтр по активности
     */
    isActive?: boolean;
    /**
     * Тип услуги (основная или дополнительная)
     */
    serviceType?: 'main' | 'additional';
};

export type AdminServicesGetAllResponse = (Array<Service>);

export type AdminServicesCreateData = {
    requestBody: CreateServiceDto;
};

export type AdminServicesCreateResponse = (Service);

export type AdminServicesGetOneData = {
    /**
     * UUID услуги
     */
    uuid: string;
};

export type AdminServicesGetOneResponse = (Service);

export type AdminServicesUpdateData = {
    requestBody: UpdateServiceDto;
    /**
     * UUID услуги
     */
    uuid: string;
};

export type AdminServicesUpdateResponse = (Service);

export type AdminServicesDeleteData = {
    /**
     * UUID услуги
     */
    uuid: string;
};

export type AdminServicesDeleteResponse = (unknown);

export type AdminAnalyticsGetStatsData = {
    /**
     * Дата начала периода в формате ISO 8601
     */
    dateFrom: string;
    /**
     * Дата окончания периода в формате ISO 8601
     */
    dateTo: string;
    /**
     * Период для сравнения статистики
     */
    period: 'day' | 'week' | 'month';
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminAnalyticsGetStatsResponse = (AnalyticsStatsResponseDto);

export type AdminAnalyticsGetTopServicesData = {
    /**
     * Дата начала периода в формате ISO 8601
     */
    dateFrom: string;
    /**
     * Дата окончания периода в формате ISO 8601
     */
    dateTo: string;
    /**
     * Максимальное количество услуг в топе
     */
    limit?: number;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminAnalyticsGetTopServicesResponse = (AnalyticsTopServicesResponseDto);

export type AdminAnalyticsGetLoadChartData = {
    /**
     * Дата начала периода в формате ISO 8601
     */
    dateFrom: string;
    /**
     * Дата окончания периода в формате ISO 8601
     */
    dateTo: string;
    /**
     * Период группировки данных графика (по дням недели или по часам)
     */
    period: 'day' | 'week' | 'month';
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid: string;
};

export type AdminAnalyticsGetLoadChartResponse = (AnalyticsLoadChartResponseDto);

export type AuditLogsListData = {
    /**
     * Тип действия
     */
    action?: 'client_register' | 'client_login' | 'client_set_phone' | 'client_refresh_token' | 'admin_login' | 'admin_logout' | 'superadmin_impersonate_sc' | 'client_update_profile' | 'client_delete_account' | 'client_create_car' | 'client_update_car' | 'client_delete_car' | 'booking_create' | 'booking_cancel' | 'booking_status_update' | 'payment_init' | 'payment_status_update' | 'payment_webhook_tbank' | 'payment_webhook_tochka' | 'payment_cancel' | 'payment_success' | 'payment_failed' | 'payout_success' | 'payout_failed' | 'receipt_created' | 'receipt_fiscalized' | 'payment_scheme_template_propagate' | 'payment_scheme_template_applied';
    /**
     * UUID администратора
     */
    adminUuid?: string;
    /**
     * UUID бронирования
     */
    bookingUuid?: string;
    /**
     * UUID клиента
     */
    clientUuid?: string;
    /**
     * Начало периода (ISO 8601)
     */
    dateFrom?: string;
    /**
     * Конец периода (ISO 8601)
     */
    dateTo?: string;
    /**
     * Количество записей (макс. 200)
     */
    limit?: number;
    /**
     * Смещение
     */
    offset?: number;
    /**
     * UUID платежа
     */
    paymentUuid?: string;
    /**
     * UUID сервисного центра
     */
    serviceCenterUuid?: string;
    /**
     * UUID услуги
     */
    serviceUuid?: string;
};

export type AuditLogsListResponse = (unknown);

export type AuditLogGetData = {
    uuid: string;
};

export type AuditLogGetResponse = (unknown);

export type DadataControllerSuggestPartyData = {
    requestBody: SuggestPartyDto;
};

export type DadataControllerSuggestPartyResponse = (unknown);

export type DadataControllerFindPartyData = {
    requestBody: FindPartyDto;
};

export type DadataControllerFindPartyResponse = (unknown);

export type DadataControllerSuggestBankData = {
    requestBody: SuggestBankDto;
};

export type DadataControllerSuggestBankResponse = (unknown);

export type DadataControllerFindBankData = {
    requestBody: FindBankDto;
};

export type DadataControllerFindBankResponse = (unknown);

export type DadataControllerSuggestAddressData = {
    requestBody: SuggestAddressDto;
};

export type DadataControllerSuggestAddressResponse = (unknown);

export type DadataControllerCleanAddressData = {
    requestBody: CleanAddressDto;
};

export type DadataControllerCleanAddressResponse = (unknown);

export type AdminFeedbackSettingsGetResponse = (FeedbackSettingsResponseDto);

export type AdminFeedbackSettingsUpdateData = {
    requestBody: UpdateFeedbackSettingsDto;
};

export type AdminFeedbackSettingsUpdateResponse = (FeedbackSettingsResponseDto);

export type FeedbackTopicsListResponse = (Array<TopicResponseDto>);

export type AdminFeedbackTopicCreateData = {
    requestBody: CreateTopicDto;
};

export type AdminFeedbackTopicCreateResponse = (TopicResponseDto);

export type AdminFeedbackTopicListResponse = (Array<TopicResponseDto>);

export type AdminFeedbackTopicUpdateData = {
    requestBody: UpdateTopicDto;
    /**
     * UUID темы
     */
    uuid: string;
};

export type AdminFeedbackTopicUpdateResponse = (TopicResponseDto);

export type AdminFeedbackTopicDeleteData = {
    /**
     * UUID темы
     */
    uuid: string;
};

export type AdminFeedbackTopicDeleteResponse = (void);

export type FeedbackCreateData = {
    formData: {
        topic_uuid?: string;
        name?: string;
        email: string;
        message: string;
        files?: Array<Blob | File>;
    };
};

export type FeedbackCreateResponse = (FeedbackResponseDto);

export type AdminFeedbackListData = {
    /**
     * Размер страницы
     */
    limit?: number;
    /**
     * Номер страницы
     */
    page?: number;
    /**
     * Поиск по теме, имени, email, телефону отправителя и тексту обращения
     */
    search?: string;
    /**
     * Фильтр по статусу
     */
    status?: 'new' | 'in_progress' | 'resolved' | 'closed';
    /**
     * Фильтр по теме обращения
     */
    topicUuid?: string;
};

export type AdminFeedbackListResponse = (unknown);

export type AdminFeedbackGetOneData = {
    /**
     * UUID обращения
     */
    uuid: string;
};

export type AdminFeedbackGetOneResponse = (FeedbackDetailResponseDto);

export type AdminFeedbackDeleteData = {
    /**
     * UUID обращения
     */
    uuid: string;
};

export type AdminFeedbackDeleteResponse = (void);

export type AdminFeedbackAddCommentData = {
    requestBody: CreateFeedbackCommentDto;
    /**
     * UUID обращения
     */
    uuid: string;
};

export type AdminFeedbackAddCommentResponse = (FeedbackTimelineEventDto);

export type AdminFeedbackUpdateStatusData = {
    requestBody: UpdateFeedbackStatusDto;
    /**
     * UUID обращения
     */
    uuid: string;
};

export type AdminFeedbackUpdateStatusResponse = (FeedbackDetailResponseDto);

export type FaqListResponse = (Array<FaqResponseDto>);

export type AdminFaqCreateData = {
    requestBody: CreateFaqDto;
};

export type AdminFaqCreateResponse = (FaqResponseDto);

export type AdminFaqListResponse = (Array<FaqResponseDto>);

export type AdminFaqGetOneData = {
    /**
     * UUID вопроса
     */
    uuid: string;
};

export type AdminFaqGetOneResponse = (FaqResponseDto);

export type AdminFaqUpdateData = {
    requestBody: UpdateFaqDto;
    /**
     * UUID вопроса
     */
    uuid: string;
};

export type AdminFaqUpdateResponse = (FaqResponseDto);

export type AdminFaqDeleteData = {
    /**
     * UUID вопроса
     */
    uuid: string;
};

export type AdminFaqDeleteResponse = (void);

export type GasStationsListData = {
    /**
     * Широта первой угловой точки видимой области карты (например, левый нижний угол)
     */
    bboxLat1?: number;
    /**
     * Широта второй угловой точки видимой области карты (например, правый верхний угол)
     */
    bboxLat2?: number;
    /**
     * Долгота первой угловой точки видимой области карты (например, левый нижний угол)
     */
    bboxLon1?: number;
    /**
     * Долгота второй угловой точки видимой области карты (например, правый верхний угол)
     */
    bboxLon2?: number;
    /**
     * Широта пользователя
     */
    lat?: number;
    /**
     * Количество элементов на странице. Если не передан — возвращаются все записи без пагинации
     */
    limit?: number;
    /**
     * Долгота пользователя
     */
    lon?: number;
    /**
     * Номер страницы (начиная с 1). Учитывается только при переданном limit
     */
    page?: number;
    /**
     * Фильтр по статусу очереди: yes — только status yes и queue, no — только status yes. Если не передан — фильтр не применяется
     */
    queue?: 'yes' | 'no';
    /**
     * Радиус поиска в км
     */
    radiusKm?: number;
};

export type GasStationsListResponse = (GasStationsListResponseDto);

export type GasStationsCreateUserData = {
    requestBody: CreateUserGasStationDto;
};

export type GasStationsCreateUserResponse = (GasStationResponseDto);

export type GasStationsMapData = {
    /**
     * Широта первой угловой точки видимой области карты (например, левый нижний угол)
     */
    bboxLat1: number;
    /**
     * Широта второй угловой точки видимой области карты (например, правый верхний угол)
     */
    bboxLat2: number;
    /**
     * Долгота первой угловой точки видимой области карты (например, левый нижний угол)
     */
    bboxLon1: number;
    /**
     * Долгота второй угловой точки видимой области карты (например, правый верхний угол)
     */
    bboxLon2: number;
    /**
     * Показывать только АЗС с заправкой в канистру
     */
    canisterOnly?: boolean;
    /**
     * Фильтр по типам топлива: список полей price_* через запятую (например price_ai_92,price_dt). Заправка попадает в выборку, если доступно хотя бы одно из указанных топлив.
     */
    fuels?: string;
    /**
     * Фильтр по статусу очереди: yes — только status yes и queue, no — только status yes
     */
    queue?: 'yes' | 'no';
    /**
     * Текущий уровень зума карты
     */
    zoom: number;
};

export type GasStationsMapResponse = (GasStationsMapResponseDto);

export type GasStationsListSubscriptionsResponse = (Array<GasStationSubscriptionResponseDto>);

export type GasStationsListFavoritesResponse = (GasStationsListResponseDto);

export type GasStationsGetOneData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type GasStationsGetOneResponse = (GasStationResponseDto);

export type GasStationToggleFavoriteData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type GasStationToggleFavoriteResponse = (ToggleGasStationFavoriteResponseDto);

export type GasStationUpsertSubscriptionData = {
    requestBody: UpsertGasStationSubscriptionDto;
    /**
     * UUID заправки
     */
    uuid: string;
};

export type GasStationUpsertSubscriptionResponse = (GasStationSubscriptionResponseDto);

export type GasStationRemoveSubscriptionData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type GasStationRemoveSubscriptionResponse = (void);

export type GasStationsSubmitReportData = {
    requestBody: SubmitGasStationReportDto;
    /**
     * UUID заправки
     */
    uuid: string;
};

export type GasStationsSubmitReportResponse = (GasStationResponseDto);

export type AdminGasStationsBulkScanData = {
    requestBody: BulkGasStationScanDto;
};

export type AdminGasStationsBulkScanResponse = (BulkGasStationScanResponseDto);

export type AdminGasStationsCreateData = {
    requestBody: CreateGasStationDto;
};

export type AdminGasStationsCreateResponse = (GasStationResponseDto);

export type AdminGasStationsListResponse = (Array<GasStationResponseDto>);

export type AdminGasStationsGetOneData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type AdminGasStationsGetOneResponse = (GasStationResponseDto);

export type AdminGasStationsUpdateData = {
    requestBody: UpdateGasStationDto;
    /**
     * UUID заправки
     */
    uuid: string;
};

export type AdminGasStationsUpdateResponse = (GasStationResponseDto);

export type AdminGasStationsDeleteData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type AdminGasStationsDeleteResponse = (void);

export type AdminGasStationsReportsData = {
    /**
     * UUID заправки
     */
    uuid: string;
};

export type AdminGasStationsReportsResponse = (Array<GasStationReportResponseDto>);

export type SystemSettingsGetPublicResponse = (PublicSystemSettingsResponseDto);

export type AdminSystemSettingsGetResponse = (SystemSettingsResponseDto);

export type AdminSystemSettingsUpdateData = {
    requestBody: UpdateSystemSettingsDto;
};

export type AdminSystemSettingsUpdateResponse = (SystemSettingsResponseDto);

export type AdminSystemSettingsGetByKeyData = {
    /**
     * Ключ настройки
     */
    key: string;
};

export type AdminSystemSettingsGetByKeyResponse = (SystemSettingEntryDto);

export type HelpListServicesResponse = (Array<HelpClientServiceDto>);

export type HelpQuoteData = {
    requestBody: HelpQuoteRequestDto;
};

export type HelpQuoteResponse = (HelpQuoteResponseDto);

export type HelpGetActiveOrderResponse = (HelpActiveOrderResponseDto);

export type HelpCreateOrderData = {
    formData: {
        kind: 'tow' | 'fuel' | 'jump_start';
        car_uuid: string;
        /**
         * JSON объекта точки pickup
         */
        pickup: string;
        /**
         * JSON объекта точки dropoff
         */
        dropoff?: string;
        blocked_wheels?: number;
        hard_to_access?: boolean;
        comment?: string;
        files?: Array<Blob | File>;
    };
};

export type HelpCreateOrderResponse = (HelpOrderDto);

export type HelpGetOrderData = {
    uuid: string;
};

export type HelpGetOrderResponse = (HelpOrderDto);

export type HelpCancelOrderData = {
    uuid: string;
};

export type HelpCancelOrderResponse = (HelpOrderDto);

export type SuperadminHelpOrdersMetricsResponse = (HelpOrdersMetricsDto);

export type SuperadminListHelpOrdersResponse = (SuperadminHelpOrdersListResponseDto);

export type SuperadminGetHelpOrderData = {
    uuid: string;
};

export type SuperadminGetHelpOrderResponse = (SuperadminHelpOrderDetailDto);

export type SuperadminUpdateHelpOrderData = {
    requestBody: UpdateHelpOrderDto;
    uuid: string;
};

export type SuperadminUpdateHelpOrderResponse = (SuperadminHelpOrderDetailDto);

export type SuperadminUpdateHelpOrderStatusData = {
    requestBody: UpdateHelpOrderStatusDto;
    uuid: string;
};

export type SuperadminUpdateHelpOrderStatusResponse = (SuperadminHelpOrderDetailDto);

export type SuperadminCommentHelpOrderData = {
    requestBody: HelpOrderCommentDto;
    uuid: string;
};

export type SuperadminCommentHelpOrderResponse = (SuperadminHelpOrderDetailDto);

export type SuperadminNotifyHelpOrderData = {
    requestBody: HelpOrderNotifyDto;
    uuid: string;
};

export type SuperadminNotifyHelpOrderResponse = (SuperadminHelpOrderDetailDto);

export type SuperadminListHelpServicesResponse = (Array<HelpServiceAdminDto>);

export type SuperadminCreateHelpServiceData = {
    requestBody: CreateHelpServiceDto;
};

export type SuperadminCreateHelpServiceResponse = (HelpServiceAdminDto);

export type SuperadminUpdateHelpServiceData = {
    requestBody: UpdateHelpServiceDto;
    uuid: string;
};

export type SuperadminUpdateHelpServiceResponse = (HelpServiceAdminDto);

export type SuperadminDeleteHelpServiceData = {
    uuid: string;
};

export type SuperadminDeleteHelpServiceResponse = (void);

export type SuperadminListHelpExecutorsResponse = (Array<HelpExecutorAdminDto>);

export type SuperadminCreateHelpExecutorData = {
    requestBody: CreateHelpExecutorDto;
};

export type SuperadminCreateHelpExecutorResponse = (HelpExecutorAdminDto);

export type SuperadminUpdateHelpExecutorData = {
    requestBody: UpdateHelpExecutorDto;
    uuid: string;
};

export type SuperadminUpdateHelpExecutorResponse = (HelpExecutorAdminDto);

export type SuperadminDeleteHelpExecutorData = {
    uuid: string;
};

export type SuperadminDeleteHelpExecutorResponse = (void);

export type AdminEmployeePositionsGetListData = {
    serviceCenterUuid: string;
};

export type AdminEmployeePositionsGetListResponse = (EmployeePositionListResponseDto);

export type AdminEmployeesGetListData = {
    isActive?: boolean;
    limit?: number;
    offset?: number;
    order?: 'ASC' | 'DESC';
    positionUuid?: string;
    /**
     * Поиск по имени, фамилии и телефону
     */
    search?: string;
    serviceCenterUuid: string;
    sort?: 'last_name' | 'phone' | 'email' | 'position' | 'created_at';
};

export type AdminEmployeesGetListResponse = (EmployeeListResponseDto);

export type AdminEmployeesCreateData = {
    requestBody: CreateEmployeeDto;
};

export type AdminEmployeesCreateResponse = (EmployeeDetailDto);

export type AdminEmployeesGetOneData = {
    uuid: string;
};

export type AdminEmployeesGetOneResponse = (EmployeeDetailDto);

export type AdminEmployeesUpdateData = {
    requestBody: UpdateEmployeeDto;
    uuid: string;
};

export type AdminEmployeesUpdateResponse = (EmployeeDetailDto);

export type AdminEmployeesDeleteData = {
    uuid: string;
};

export type AdminEmployeesDeleteResponse = (unknown);

export type AdminPaymentSchemeTemplatesGetListData = {
    includeArchived?: boolean;
    limit?: number;
    offset?: number;
    /**
     * Поиск по названию шаблона
     */
    search?: string;
    serviceCenterUuid: string;
};

export type AdminPaymentSchemeTemplatesGetListResponse = (PaymentSchemeTemplateListResponseDto);

export type AdminPaymentSchemeTemplatesCreateData = {
    requestBody: CreatePaymentSchemeTemplateDto;
};

export type AdminPaymentSchemeTemplatesCreateResponse = (PaymentSchemeTemplateDto);

export type AdminPaymentSchemeTemplatesGetOneData = {
    uuid: string;
};

export type AdminPaymentSchemeTemplatesGetOneResponse = (PaymentSchemeTemplateDto);

export type AdminPaymentSchemeTemplatesUpdateData = {
    requestBody: UpdatePaymentSchemeTemplateDto;
    uuid: string;
};

export type AdminPaymentSchemeTemplatesUpdateResponse = (PaymentSchemeTemplateWithPropagationDto);

export type AdminPaymentSchemeTemplatesDeleteData = {
    uuid: string;
};

export type AdminPaymentSchemeTemplatesDeleteResponse = (unknown);

export type AdminPaymentSchemeTemplatesPropagateData = {
    /**
     * true — посчитать будущий результат и ничего не записывать (без FOR UPDATE)
     */
    dryRun?: boolean;
    uuid: string;
};

export type AdminPaymentSchemeTemplatesPropagateResponse = (PropagationResultDto);

export type AdminEmployeePaymentSchemeGetData = {
    employeeUuid: string;
};

export type AdminEmployeePaymentSchemeGetResponse = (PaymentSchemeDto);

export type AdminEmployeePaymentSchemeUpdateData = {
    employeeUuid: string;
    requestBody: UpdateEmployeePaymentSchemeDto;
};

export type AdminEmployeePaymentSchemeUpdateResponse = (PaymentSchemeDto);

export type AdminEmployeePaymentSchemeApplyTemplateData = {
    /**
     * true — посчитать будущий результат и ничего не записывать (без FOR UPDATE)
     */
    dryRun?: boolean;
    employeeUuid: string;
    requestBody: ApplyPaymentSchemeTemplateDto;
};

export type AdminEmployeePaymentSchemeApplyTemplateResponse = (PaymentSchemeDto);

export type AdminEmployeePaymentSchemeUpdateServiceData = {
    employeeUuid: string;
    requestBody: UpdatePaymentSchemeServiceDto;
    serviceUuid: string;
};

export type AdminEmployeePaymentSchemeUpdateServiceResponse = (PaymentSchemeDto);

export type AdminEmployeePaymentSchemeResetOverridesData = {
    employeeUuid: string;
};

export type AdminEmployeePaymentSchemeResetOverridesResponse = (PaymentSchemeDto);

export type SuperadminDiscountsCreateData = {
    requestBody: CreateDiscountDto;
};

export type SuperadminDiscountsCreateResponse = (DiscountResponseDto);

export type SuperadminDiscountsListData = {
    isActive?: boolean;
    /**
     * Количество элементов на странице
     */
    limit?: number;
    /**
     * Номер страницы (начиная с 1)
     */
    page?: number;
    /**
     * Глобальный поиск по всем текстовым полям
     */
    q?: string;
    /**
     * Поле для сортировки (с префиксом - для DESC). Можно указать несколько через запятую.
     */
    sort?: string;
    type?: 'manual' | 'promocode';
};

export type SuperadminDiscountsListResponse = (DiscountListResponseDto);

export type SuperadminDiscountsListUsagesData = {
    /**
     * Количество элементов на странице
     */
    limit?: number;
    /**
     * Номер страницы (начиная с 1)
     */
    page?: number;
    /**
     * Глобальный поиск по всем текстовым полям
     */
    q?: string;
    /**
     * Поле для сортировки (с префиксом - для DESC). Можно указать несколько через запятую.
     */
    sort?: string;
    uuid: string;
};

export type SuperadminDiscountsListUsagesResponse = (DiscountUsageListResponseDto);

export type SuperadminDiscountsGetData = {
    uuid: string;
};

export type SuperadminDiscountsGetResponse = (DiscountResponseDto);

export type SuperadminDiscountsUpdateData = {
    requestBody: UpdateDiscountDto;
    uuid: string;
};

export type SuperadminDiscountsUpdateResponse = (DiscountResponseDto);